import { Fragment, useState, useEffect, useMemo, useRef } from 'react';
import {
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Table,
    TableBody,
    TableHead,
    TableRow,
    TableCell,
    Button,
    TextField,
    Tooltip,
    Typography,
    Card,
    CardContent,
    Grid,
    Divider,
    Chip,
    IconButton,
    MenuItem,
    FormControlLabel,
    Checkbox,
    Alert,
    Snackbar,
    AlertColor
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlined';
import moment from 'moment';
import JsBarcode from 'jsbarcode';
import { toString as generateQrSvg } from 'qrcode';
import ETLogo from '../../../../../assets/environment-testing.png';
import { DeleteOutline, Add, Remove } from '@mui/icons-material';
import {
    downloadOrderAttachment, getAllContainers, getQualityAndPackingItems,
    addContainerToBottleOrder, addPackageToBottleOrder, updateOrderApi,
    deleteContainerItem, deletePackageItem
} from 'services';
import { DateInputField } from 'components';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { AddContainer } from './AddContainer';
import { BottleGroupFromQuote } from './BottleGroupFromQuote';
import { QuoteContainerCheckoutDialog } from 'modules/quote/ClientResult/QuoteContainerCheckoutDialog';

const printStyles = `
  @media print {
    /* Hide everything by default */
    * {
      visibility: hidden !important;
    }
    
    /* Hide main page content completely */
    body > *:not(.MuiDialog-root),
    #root > *:not(.MuiDialog-root),
    .MuiDataGrid-root,
    nav, header, footer,
    [class*="DataGrid"],
    [class*="Breadcrumb"] {
      display: none !important;
      visibility: hidden !important;
    }
    
    /* Only show print-area-show sections */
    .print-area-show,
    .print-area-show * {
      visibility: visible !important;
    }
    
    /* Hide all buttons and interactive elements during print */
    .no-print,
    .MuiButton-root,
    .MuiIconButton-root,
    .action-buttons,
    .print-button-container {
      display: none !important;
      visibility: hidden !important;
    }
    
    /* Show status text instead of tick icons in print */
    .print-status-text {
      display: block !important;
      visibility: visible !important;
    }
    
    .print-hide {
      display: none !important;
      visibility: hidden !important;
    }

        .print-hide-price,
        .print-hide-price *,
        .despatch-details-grid > .print-hide-price,
        .despatch-details-grid > .print-hide-price * {
            display: none !important;
            visibility: hidden !important;
            width: 0 !important;
            max-width: 0 !important;
            min-width: 0 !important;
            padding: 0 !important;
            margin: 0 !important;
            overflow: hidden !important;
        }

        .recipient-instructions {
            width: 100% !important;
            flex: 0 0 100% !important;
            max-width: 100% !important;
            margin-top: 4px !important;
        }

        .recipient-instruction-row {
            display: flex !important;
            align-items: flex-start !important;
            width: 100% !important;
            margin-bottom: 6px !important;
            gap: 8px !important;
        }

        .recipient-instruction-label {
            width: 160px !important;
            min-width: 160px !important;
            flex-shrink: 0 !important;
            font-weight: 600 !important;
            white-space: nowrap !important;
        }

        .recipient-instruction-value {
            flex: 1 !important;
            min-width: 0 !important;
            white-space: normal !important;
            word-break: break-word !important;
            overflow-wrap: anywhere !important;
        }

        .print-top-separator {
            display: block !important;
            visibility: visible !important;
            width: 100% !important;
            border: 0 !important;
            border-top: 1px solid #b9b9b9 !important;
            margin: 2px 0 12px 0 !important;
            padding: 0 !important;
            box-sizing: border-box !important;
        }
    
    /* Reset dialog structure for print */
    .MuiDialog-root {
      position: relative !important;
      transform: none !important;
      left: 0 !important;
      top: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      width: 100% !important;
      height: auto !important;
      max-width: 100% !important;
      max-height: none !important;
    }
    
    .MuiDialog-container {
      position: static !important;
      display: block !important;
      padding: 0 !important;
      margin: 0 !important;
      width: 100% !important;
      height: auto !important;
    }
    
    .MuiDialog-paper {
      position: static !important;
      margin: 0 !important;
      padding: 0 !important;
      box-shadow: none !important;
      background: white !important;
      border: none !important;
      max-width: 100% !important;
      width: 100% !important;
      height: auto !important;
      border-radius: 0 !important;
      transform: none !important;
    }
    
    .MuiDialogTitle-root,
    .MuiDialogContent-root {
      padding: 0 !important;
      margin: 0 !important;
      width: 100% !important;
    }
    
    .MuiBackdrop-root {
      display: none !important;
      visibility: hidden !important;
    }
    
    /* Fix Grid layout for print */
    .MuiGrid-root {
      display: flex !important;
      flex-wrap: wrap !important;
      width: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
      box-sizing: border-box !important;
    }
    
        /* Contact and Schedule side by side */
        .recipient-summary-grid > .MuiGrid-item:nth-child(1),
        .recipient-summary-grid > .MuiGrid-item:nth-child(2) {
      width: 48% !important;
      flex: 0 0 48% !important;
      max-width: 48% !important;
      padding: 0 1% !important;
      box-sizing: border-box !important;
            width: 50% !important;
    }
    
    /* Delivery address full width */
        .recipient-summary-grid > .MuiGrid-item:nth-child(3) {
      width: 100% !important;
      flex: 0 0 100% !important;
      max-width: 100% !important;
      padding: 0 1% !important;
      box-sizing: border-box !important;
      margin: 0 !important;
      display: block !important;
      visibility: visible !important;
    }
    
    /* Force delivery address section to show */
    .delivery-address-section {
      display: block !important;
      visibility: visible !important;
      width: 100% !important;
    }

        .delivery-address-section > .MuiGrid-root {
            display: flex !important;
            flex-wrap: wrap !important;
            width: 100% !important;
            margin: 0 !important;
        }

        .delivery-address-section > .MuiGrid-root > .MuiGrid-item,
        .delivery-address-section > .MuiGrid-root > .recipient-instructions {
            width: 100% !important;
            flex: 0 0 100% !important;
            max-width: 100% !important;
            padding: 0 !important;
            margin: 0 0 6px 0 !important;
            box-sizing: border-box !important;
            display: block !important;
        }

        .despatch-details-grid {
            display: flex !important;
            flex-wrap: wrap !important;
            width: 100% !important;
            margin: 0 !important;
        }

        .despatch-details-grid > .MuiGrid-item {
            width: 33.33% !important;
            flex: 0 0 33.33% !important;
            max-width: 33.33% !important;
            padding: 0 8px 6px 0 !important;
            margin: 0 !important;
            box-sizing: border-box !important;
        }

        .despatch-print-field .MuiTypography-body2,
        .despatch-print-field .MuiTypography-body1 {
            text-align: left !important;
            white-space: normal !important;
            line-height: 1.4 !important;
            display: block !important;
        }
    
    /* Force divider to show */
    .print-area-show .MuiDivider-root {
      display: block !important;
      visibility: visible !important;
      margin: 4px 0 !important;
      border-top: 1px solid #ccc !important;
    }
    
    /* CRITICAL: Allow content to flow across multiple pages */
    .print-area-show {
      width: 100% !important;
      max-width: 100% !important;
      padding: 8px !important;
      margin: 0 !important;
      background: white !important;
      box-sizing: border-box !important;
      overflow: visible !important;
      position: static !important;
      transform: none !important;
      /* REMOVE height restrictions to allow multiple pages */
      height: auto !important;
      max-height: none !important;
      min-height: auto !important;
    }
    
    /* Cards - COMPACT LAYOUT */
    .MuiCard-root {
      width: 100% !important;
      max-width: 100% !important;
      margin: 0 0 8px 0 !important;
      padding: 6px !important;
      box-sizing: border-box !important;
      border: 1px solid #ccc !important;
      /* Allow cards to break across pages if needed */
      page-break-inside: auto !important;
      break-inside: auto !important;
    }

    /* Containers/Bottle Groups/Quality & Packing wrap a bordered table already, drop the outer card border */
    .print-table-card {
      border: none !important;
      padding: 0 !important;
    }
    
    .MuiCardContent-root {
      width: 100% !important;
      padding: 6px !important;
      margin: 0 !important;
      box-sizing: border-box !important;
    }
    
    /* Print area - TABLE CONTAINER - ALLOW FULL HEIGHT */
    .print-area {
      width: 100% !important;
      max-width: 100% !important;
      overflow: visible !important;
      margin: 0 !important;
      padding: 0 !important;
      box-sizing: border-box !important;
      /* REMOVE flex restrictions to allow natural table flow */
      height: auto !important;
      max-height: none !important;
    }
    
    /* Table - ALLOW NATURAL PAGE BREAKS */
    .print-area table {
      width: 100% !important;
      max-width: 100% !important;
      border-collapse: collapse !important;
      margin: 0 !important;
      background: white !important;
      table-layout: fixed !important;
      box-sizing: border-box !important;
      /* ALLOW table to break across pages */
      page-break-inside: auto !important;
      break-inside: auto !important;
    }
    
    /* Column widths - OPTIMIZED TO PREVENT HEADER TEXT OVERLAP */
    .print-area th:nth-child(1),
    .print-area td:nth-child(1) {
      width: 30% !important;
      max-width: 30% !important;
      min-width: 160px !important;
    }
    
    .print-area th:nth-child(2),
    .print-area td:nth-child(2) {
      width: 14% !important;
      max-width: 14% !important;
      min-width: 100px !important;
    }
    
    .print-area th:nth-child(3),
    .print-area td:nth-child(3) {
      width: 12% !important;
      max-width: 12% !important;
      min-width: 100px !important;
    }
    
    .print-area th:nth-child(4),
    .print-area td:nth-child(4) {
      width: 16% !important;
      max-width: 16% !important;
      min-width: 100px !important;
    }
    
    .print-area th:nth-child(5),
    .print-area td:nth-child(5) {
      width: 16% !important;
      max-width: 16% !important;
      min-width: 100px !important;
    }

    .print-area th:nth-child(6),
    .print-area td:nth-child(6) {
      width: 22% !important;
      max-width: 22% !important;
      min-width: 100px !important;
    }

    .print-area th:nth-child(7),
    .print-area td:nth-child(7) {
      width: 16% !important;
      max-width: 16% !important;
      min-width: 100px !important;
    }
    
    /* TABLE CELLS - IMPROVED FONT AND LINE HEIGHT */
    .print-area td {
      border: 1px solid #b9b9b9ff !important;
      padding: 8px 6px !important;
      font-size: 12px !important;
      background: white !important;
      word-wrap: break-word !important;
      overflow: visible !important;
      vertical-align: middle !important;
      box-sizing: border-box !important;
      line-height: 1.6 !important;
      min-height: 40px !important;
      /* ALLOW WRAPPING FOR LONG CONTENT */
      white-space: normal !important;
      text-overflow: ellipsis !important;
    }
    
    /* TABLE HEADERS - FIXED OVERLAPPING TEXT */
    .print-area th {
      border: 1px solid #b9b9b9ff !important;
      background-color: #ebebeb !important;
      color: #000000 !important;
      font-weight: 600 !important;
      -webkit-print-color-adjust: exact !important;
      color-adjust: exact !important;
      print-color-adjust: exact !important;
      font-size: 12px !important;
      line-height: 1.4 !important;
      padding: 6px 4px !important;
      vertical-align: middle !important;
      min-height: 36px !important;
      /* ALLOW TEXT WRAPPING FOR HEADERS */
      white-space: normal !important;
      word-wrap: break-word !important;
      overflow: hidden !important;
      text-align: left !important;
      box-sizing: border-box !important;
    }
    
    /* STATUS COLUMN - SPECIFIC STYLING */
    .print-area td:nth-child(1),
    .print-area th:nth-child(1) {
      text-align: left !important;
      padding: 6px 4px !important;
      white-space: nowrap !important;
    }
    
    /* CONTAINER NAME COLUMN - ALLOW WRAPPING */
    .print-area td:nth-child(2),
    .print-area th:nth-child(2) {
      text-align: left !important;
      white-space: normal !important;
      word-wrap: break-word !important;
    }
    
    /* QUANTITY COLUMNS - LEFT ALIGN */
    .print-area td:nth-child(3),
    .print-area th:nth-child(3),
    .print-area td:nth-child(4),
    .print-area th:nth-child(4) {
      text-align: left !important;
      white-space: normal !important;
      word-wrap: break-word !important;
    }
    
    /* COMMENTS COLUMN - ALLOW WRAPPING */
    .print-area td:nth-child(5),
    .print-area th:nth-child(5) {
      text-align: left !important;
      white-space: normal !important;
      word-wrap: break-word !important;
    }

    /* COMMENTS COLUMN - ALLOW WRAPPING */
    .print-area td:nth-child(6),
    .print-area th:nth-child(6) {
      text-align: left !important;
      white-space: normal !important;
      word-wrap: break-word !important;
    }

    /* COMMENTS COLUMN - ALLOW WRAPPING */
    .print-area td:nth-child(7),
    .print-area th:nth-child(7) {
      text-align: left !important;
      white-space: normal !important;
      word-wrap: break-word !important;
    }
    
    /* Hide input field borders in print */
    .MuiTextField-root {
      width: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
      box-sizing: border-box !important;
    }
    
    .MuiTextField-root .MuiOutlinedInput-notchedOutline {
      border: none !important;
    }
    
    .MuiOutlinedInput-input {
      padding: 6px !important;
      font-size: 12px !important;
      background: transparent !important;
      margin: 0 !important;
      box-sizing: border-box !important;
      line-height: 1.6 !important;
      min-height: 28px !important;
    }
    
    /* Force white background */
    body, html, #root {
      background: white !important;
      background-color: white !important;
      margin: 0 !important;
      padding: 0 !important;
      box-sizing: border-box !important;
    }
    
    /* Page setup - ALLOW MULTIPLE PAGES */
    @page {
      margin: 0.3in !important;
      size: A4 portrait !important;
    }
    
    /* ALLOW CONTENT TO FLOW ACROSS MULTIPLE PAGES */
    .print-area-show {
      page-break-inside: auto !important;
      break-inside: auto !important;
    }
    
    .recipient-details {
      page-break-inside: auto !important;
      break-inside: auto !important;
      page-break-after: auto !important;
    }
    
    .print-area {
      page-break-inside: auto !important;
      break-inside: auto !important;
    }
    
    .print-area table {
      page-break-inside: auto !important;
      break-inside: auto !important;
    }
    
    /* Allow table rows to break across pages */
    .print-area tbody tr {
      page-break-inside: avoid !important;
      break-inside: avoid !important;
    }
    
    /* Keep table header on each page */
    .print-area thead {
      display: table-header-group !important;
    }
    
    /* Hide helper text in print */
    .MuiFormHelperText-root {
      display: none !important;
      visibility: hidden !important;
    }
    
    /* Recipient details - ALLOW NATURAL HEIGHT */
    .recipient-details {
      width: 100% !important;
      margin-bottom: 8px !important;
      padding: 0 !important;
      box-sizing: border-box !important;
      /* REMOVE height restrictions */
      height: auto !important;
      max-height: none !important;
      overflow: visible !important;
    }
    
    /* Typography - IMPROVED SIZING */
    .print-area-show .MuiTypography-h6 {
      font-size: 16px !important;
      margin: 0 0 4px 0 !important;
      padding: 0 !important;
      line-height: 1.4 !important;
      font-weight: 600 !important;
    }
    
    .print-area-show .MuiTypography-subtitle2 {
      font-size: 12px !important;
      margin: 0 0 3px 0 !important;
      padding: 0 !important;
      line-height: 1.4 !important;
      font-weight: 600 !important;
    }
    
    .print-area-show .MuiTypography-body2 {
      font-size: 13px !important;
      margin: 0 0 3px 0 !important;
      padding: 0 !important;
      line-height: 1.4 !important;
    }
    
    .print-area-show .MuiTypography-subtitle1 {
      font-size: 12px !important;
      margin: 0 0 3px 0 !important;
      padding: 0 !important;
      line-height: 1.4 !important;
    }
    
    /* Icons */
    .print-area-show .MuiSvgIcon-root {
      font-size: 12px !important;
    }
    
    /* Status text in print - PREVENT LINE WRAPPING */
    .print-status-text .MuiTypography-body2 {
      font-size: 12px !important;
      line-height: 1.4 !important;
      font-weight: 600 !important;
      white-space: nowrap !important;
      text-align: center !important;
    }

    /* Bottle group name in print - keep left aligned and wrap long names */
    .print-status-text .group-name-print-text {
      text-align: left !important;
      white-space: normal !important;
      word-break: break-word !important;
      overflow-wrap: anywhere !important;
    }
    
    /* SHOW COMMENTS SECTION IN PRINT */
    .print-area-show .MuiCard-root:last-child {
      display: block !important;
      visibility: visible !important;
      margin-top: 8px !important;
    }
    
    /* Comments section typography */
    .print-area-show .MuiCard-root .MuiTypography-body2 {
      font-size: 12px !important;
      line-height: 1.6 !important;
    }
    
    /* TITLE SECTION */
    .MuiDialogTitle-root {
      padding: 4px 0 !important;
      margin-bottom: 6px !important;
    }
    
    .MuiDialogContent-root {
      padding: 0 !important;
    }
    
    /* Table row height optimization */
    .print-area tbody tr {
      height: auto !important;
      min-height: 40px !important;
    }
    
    .print-area th {
      height: auto !important;
      min-height: 36px !important;
    }
    
    .print-area td {
      height: auto !important;
      min-height: 40px !important;
    }
    
    /* REMOVE SCALING - Allow natural page flow */
    .print-area-show {
      transform: none !important;
      width: 100% !important;
    }
    
    /* Better spacing */
    .print-area-show .MuiBox-root {
      margin: 0 !important;
      padding: 0 !important;
      box-sizing: border-box !important;
    }
    
    /* Force content to fit properly */
    .print-area-show * {
      box-sizing: border-box !important;
      max-width: 100% !important;
    }
    
    /* Table cells content */
    .print-area td .MuiTextField-root {
      font-size: 12px !important;
      width: 100% !important;
    }
    
    .print-area td .MuiTextField-root input {
      font-size: 12px !important;
      padding: 6px !important;
      box-sizing: border-box !important;
      line-height: 1.6 !important;
      min-height: 28px !important;
    }
    
    /* Ensure all table content is visible */
    .print-area tbody {
      display: table-row-group !important;
    }
    
    .print-area tr {
      display: table-row !important;
    }
    
    .print-area td,
    .print-area th {
      display: table-cell !important;
    }
  }
`;

const labelPrintStyles = `
    @media print {
        :root {
            --page-width: 150mm;
            --page-height: 100mm;
            --page-padding-left: 1.5mm;
            --page-padding-right: 1.5mm;
            --page-padding-top: 1.5mm;
            --page-padding-bottom: 1.5mm;
            --label-width: calc(var(--page-width) - var(--page-padding-left) - var(--page-padding-right));
            --label-height: calc(var(--page-height) - var(--page-padding-top) - var(--page-padding-bottom));
            --label-card-height: calc(var(--label-height) - 4mm);
            --page-top-space: 0;
            --label-border: #9d9d9d;
            --label-inner-border: #c8ced8;
            --label-top-section-height: 3.55cm;
        }

        * {
            visibility: hidden !important;
        }

        html,
        body,
        #root {
            width: var(--page-width) !important;
            min-width: var(--page-width) !important;
            max-width: var(--page-width) !important;
            margin: 0 !important;
            padding: 0 !important;
            overflow: visible !important;
            background: white !important;
            box-sizing: border-box !important;
        }

        body > *:not(.MuiDialog-root),
        #root > *:not(.MuiDialog-root),
        .MuiDialogTitle-root,
        .MuiDialogContent-root > *:not(.label-print-root) {
            display: none !important;
            visibility: hidden !important;
        }

        .MuiDialog-root,
        .MuiDialog-container,
        .MuiDialog-paper {
            position: static !important;
            margin: 0 !important;
            padding: 0 !important;
            width: var(--page-width) !important;
            min-width: var(--page-width) !important;
            max-width: var(--page-width) !important;
            height: auto !important;
            max-height: none !important;
            box-shadow: none !important;
            background: white !important;
            border: none !important;
            overflow: visible !important;
            inset: 0 !important;
            transform: none !important;
        }

        .MuiDialog-container {
            display: block !important;
            width: var(--page-width) !important;
            min-width: var(--page-width) !important;
            max-width: var(--page-width) !important;
        }

        .MuiDialogContent-root {
            width: var(--page-width) !important;
            min-width: var(--page-width) !important;
            max-width: var(--page-width) !important;
            margin: 0 !important;
            padding: 0 !important;
        }

        .MuiBackdrop-root,
        .print-area-show,
        .print-button-container,
        .label-print-controls,
        .action-buttons,
        .no-print {
            display: none !important;
            visibility: hidden !important;
        }

        .label-print-root,
        .label-print-root * {
            visibility: visible !important;
        }

        .label-print-root {
            display: block !important;
            width: var(--page-width) !important;
            min-width: var(--page-width) !important;
            max-width: var(--page-width) !important;
            height: auto !important;
            max-height: none !important;
            overflow: visible !important;
            margin: 0 !important;
            padding: 0 !important;
        }

        .label-print-page {
            display: flex !important;
            flex-direction: column !important;
            position: relative !important;
            align-items: flex-start !important;
            justify-content: flex-start !important;
            width: var(--page-width) !important;
            max-width: var(--page-width) !important;
            min-height: var(--page-height) !important;
            height: var(--page-height) !important;
            max-height: var(--page-height) !important;
            padding: var(--page-padding-top) var(--page-padding-right) var(--page-padding-bottom) var(--page-padding-left) !important;
            margin: 0 !important;
            box-sizing: border-box !important;
            page-break-after: always !important;
            break-after: page !important;
            overflow: hidden !important;
        }

        .label-print-page:only-child {
            page-break-after: avoid !important;
            break-after: avoid !important;
        }

        .label-print-page:last-child {
            page-break-after: auto !important;
            break-after: auto !important;
        }

        .label-print-card {
            border: 1px solid var(--label-border) !important;
            border-radius: 10px !important;
            padding: 0 !important;
            width: var(--label-width) !important;
            height: var(--label-card-height) !important;
            margin: 0 !important;
            box-sizing: border-box !important;
            background: white !important;
            font-size: 12px !important;
            line-height: 1.35 !important;
            overflow: hidden !important;
            display: flex !important;
            flex-direction: column !important;
        }

        .label-top-strip {
            height: 0 !important;
            background: transparent !important;
        }

        .label-header {
            display: grid !important;
            grid-template-columns: 1fr 1.2fr !important;
            border-bottom: 1px solid var(--label-border) !important;
            background: #ffffff !important;
            height: 1.6cm !important;
            min-height: 1.6cm !important;
            flex: 0 0 1.6cm !important;
        }

        .label-company-block {
            border-right: 1px solid var(--label-border) !important;
            display: flex !important;
            align-items: center !important;
            justify-content: flex-start !important;
            padding: 6px 12px !important;
            min-width: 0 !important;
        }

        .label-logo {
            max-width: 100% !important;
            width: auto !important;
            max-height: 0.6cm !important;
            height: auto !important;
            display: block !important;
        }

        .label-top-barcode-block {
            display: flex !important;
            flex-direction: column !important;
            justify-content: center !important;
            align-items: center !important;
            padding: 6px 8px !important;
            gap: 4px !important;
            min-width: 0 !important;
        }

        .label-top-barcode-image {
            width: 100% !important;
            max-width: 8cm !important;
            height: 0.8cm !important;
            object-fit: contain !important;
            display: block !important;
        }

        .label-top-order-line {
            font-size: 9px !important;
            font-weight: 700 !important;
            color: #1f2f4f !important;
            text-align: center !important;
            line-height: 1.2 !important;
            width: 100% !important;
            max-width: 10cm !important;
        }

        .label-meta-label {
            font-size: 12px !important;
            line-height: 1.2 !important;
            font-weight: 600 !important;
            color: #22344f !important;
        }

        .label-meta-value {
            font-size: 12px !important;
            line-height: 1.2 !important;
            font-weight: 700 !important;
            color: #000 !important;
            margin-top: 2px !important;
            word-break: break-word !important;
        }

        .label-main {
            display: grid !important;
            grid-template-columns: 1.72fr 1.28fr !important;
            min-height: 0 !important;
            height: calc(var(--label-card-height) - 1.6cm) !important;
            flex: 1 1 auto !important;
        }

        .label-main-left {
            border-right: 1px solid var(--label-border) !important;
            padding: 0 !important;
            display: grid !important;
            grid-template-rows: var(--label-top-section-height) auto 1fr !important;
            gap: 0 !important;
            align-content: stretch !important;
            min-height: 0 !important;
        }

        .label-main-right {
            padding: 0 !important;
            display: grid !important;
            grid-template-rows: var(--label-top-section-height) minmax(0, 1fr) !important;
            gap: 0 !important;
            min-height: 0 !important;
        }

        .label-section-card {
            border: none !important;
            border-bottom: 1px solid var(--label-inner-border) !important;
            background: transparent !important;
            padding: 8px 10px 6px 10px !important;
            border-radius: 0 !important;
            min-width: 0 !important;
            min-height: 0 !important;
        }

        .label-main-right .label-section-card {
            padding-right: 8px !important;
        }

        .label-main-left .label-section-card:first-child,
        .label-main-right .label-section-card:first-child {
            height: var(--label-top-section-height) !important;
            min-height: var(--label-top-section-height) !important;
            box-sizing: border-box !important;
            overflow: hidden !important;
        }

        .label-section-title {
            display: block !important;
            margin: 0 0 4px 0 !important;
            font-size: 13px !important;
            line-height: 1.2 !important;
            font-weight: 700 !important;
            color: #0f2a54 !important;
        }

        .label-kv-row {
            display: grid !important;
            grid-template-columns: 124px minmax(0, 1fr) !important;
            column-gap: 4px !important;
            font-size: 12px !important;
            line-height: 1.22 !important;
            color: #000 !important;
            margin: 0 0 2px 0 !important;
            word-break: break-word !important;
            align-items: start !important;
            min-width: 0 !important;
        }

        .label-kv-key {
            font-weight: 700 !important;
            white-space: normal !important;
            overflow-wrap: anywhere !important;
            color: #1f2f4f !important;
        }

        .label-courier-row {
            display: grid !important;
            grid-template-columns: 1fr !important;
            gap: 0 !important;
            border-bottom: 1px solid var(--label-inner-border) !important;
            min-height: 1.25cm !important;
        }

        .label-mini-card {
            border: none !important;
            border-bottom: none !important;
            border-radius: 0 !important;
            padding: 5px 10px !important;
            background: transparent !important;
            min-width: 0 !important;
            min-height: 0.6cm !important;
            display: flex !important;
            align-items: center !important;
            gap: 6px !important;
        }

        .label-mini-card:first-child {
            border-right: none !important;
            border-bottom: 1px solid var(--label-inner-border) !important;
        }

        .label-instruction-card {
            border: none !important;
            border-bottom: none !important;
            border-radius: 0 !important;
            padding: 8px 10px !important;
            background: transparent !important;
            display: flex !important;
            flex-direction: column !important;
            min-height: 0 !important;
        }

        .label-instruction-title {
            font-size: 12px !important;
            font-weight: 600 !important;
            color: #22344f !important;
            margin-bottom: 2px !important;
            line-height: 1.2 !important;
        }

        .label-instruction-text {
            font-size: 12px !important;
            line-height: 1.25 !important;
            color: #000 !important;
            word-break: break-word !important;
            min-height: 24px !important;
            flex: 1 1 auto !important;
        }

        .label-qr-card {
            border: none !important;
            border-radius: 0 !important;
            border-top: 1px solid var(--label-inner-border) !important;
            padding: 2mm 8px !important;
            display: flex !important;
            flex: 1 1 auto !important;
            min-height: 0 !important;
            align-items: center !important;
            justify-content: center !important;
            background: transparent !important;
            overflow: hidden !important;
        }

        .label-qr-svg {
            width: 28mm !important;
            height: 28mm !important;
            display: block !important;
            max-width: 100% !important;
            max-height: 100% !important;
        }

        .label-qr-svg svg {
            display: block !important;
            width: 100% !important;
            height: 100% !important;
        }

        .label-fallback {
            font-size: 12px !important;
            text-align: center !important;
            color: #000 !important;
        }

        .label-print-page-number {
            position: static !important;
            align-self: flex-end !important;
            height: 4mm !important;
            margin: 0 !important;
            padding: 1px 2px 0 2px !important;
            text-align: right !important;
            width: auto !important;
            font-size: 10px !important;
            font-weight: 600 !important;
            color: #444 !important;
        }

        @page {
            size: 150mm 100mm !important;
            margin: 0 !important;
        }
    }
`;

const groupPrintStyles = `
    @media print {
        :root {
            --page-width: 186mm;
            --page-height: 273mm;
        }

        * {
            visibility: hidden !important;
        }

        html,
        body,
        #root {
            width: 100% !important;
            min-width: 100% !important;
            max-width: 100% !important;
            margin: 0 !important;
            padding: 0 !important;
            background: white !important;
            overflow: visible !important;
        }

        body > *:not(.MuiDialog-root),
        #root > *:not(.MuiDialog-root),
        .MuiDialogTitle-root,
        .MuiDialogContent-root > *:not(.group-print-root) {
            display: none !important;
            visibility: hidden !important;
        }

        .MuiDialog-root,
        .MuiDialog-container,
        .MuiDialog-paper {
            position: static !important;
            margin: 0 !important;
            padding: 0 !important;
            width: 100% !important;
            min-width: 100% !important;
            max-width: 100% !important;
            height: auto !important;
            max-height: none !important;
            box-shadow: none !important;
            background: white !important;
            border: none !important;
            overflow: visible !important;
            inset: 0 !important;
            transform: none !important;
        }

        .MuiDialog-container {
            display: block !important;
            width: 100% !important;
            min-width: 100% !important;
            max-width: 100% !important;
        }

        .MuiBackdrop-root,
        .print-area-show,
        .print-button-container,
        .group-print-controls,
        .action-buttons,
        .no-print {
            display: none !important;
            visibility: hidden !important;
        }

        .group-print-root,
        .group-print-root * {
            visibility: visible !important;
        }

        .group-print-root {
            display: block !important;
            width: 100% !important;
            min-width: 100% !important;
            max-width: 100% !important;
            margin: 0 !important;
            padding: 0 !important;
        }

        .group-print-page {
            display: flex !important;
            flex-direction: column !important;
            position: relative !important;
            width: 100% !important;
            min-height: var(--page-height) !important;
            height: var(--page-height) !important;
            max-height: var(--page-height) !important;
            box-sizing: border-box !important;
            margin: 0 !important;
            padding: 0 !important;
            page-break-after: always !important;
            break-after: page !important;
            overflow: visible !important;
        }

        .group-print-page:last-child {
            page-break-after: auto !important;
            break-after: auto !important;
        }

        .group-print-title {
            font-size: 16px !important;
            font-weight: 700 !important;
            color: #000 !important;
            margin: 0 0 2px 0 !important;
        }

        .group-print-subtitle {
            font-size: 12px !important;
            color: #000 !important;
            margin: 0 0 4px 0 !important;
        }

        .group-print-table {
            width: 100% !important;
            max-width: 100% !important;
            margin: 0 !important;
            border: 1px solid #b9b9b9 !important;
            border-collapse: collapse !important;
            table-layout: auto !important;
            box-sizing: border-box !important;
            page-break-inside: auto !important;
            break-inside: auto !important;
        }

        /* Repeat the header row when the table spills onto a second page */
        .group-print-table thead {
            display: table-header-group !important;
        }

        .group-print-table tr {
            page-break-inside: avoid !important;
            break-inside: avoid !important;
        }

        .group-print-table th:last-child,
        .group-print-table td:last-child {
            width: 60px !important;
            white-space: nowrap !important;
        }

        .group-print-table th,
        .group-print-table td {
            border: 1px solid #b9b9b9 !important;
            padding: 5px 6px !important;
            font-size: 14px !important;
            line-height: 1.35 !important;
            text-align: left !important;
            white-space: normal !important;
            word-wrap: break-word !important;
            word-break: break-word !important;
            overflow-wrap: anywhere !important;
            box-sizing: border-box !important;
            color: #000 !important;
        }

        /* Ensure the right-hand border always renders, even if collapse rounding drops it */
        .group-print-table th:last-child,
        .group-print-table td:last-child {
            border-right: 1px solid #b9b9b9 !important;
        }

        .group-print-table th {
            background-color: #ebebeb !important;
            font-weight: 600 !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
        }

        .group-print-parent-row td {
            font-weight: 700 !important;
            background-color: #f5f7fa !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
        }

        .group-print-child-cell {
            padding-left: 10px !important;
        }

        .group-print-page-number {
            display: block !important;
            visibility: visible !important;
            position: static !important;
            width: 100% !important;
            box-sizing: border-box !important;
            margin: auto 0 0 0 !important;
            padding: 0 !important;
            text-align: right !important;
            font-size: 12px !important;
            font-weight: 600 !important;
            color: #444 !important;
            background: white !important;
            page-break-inside: avoid !important;
            break-inside: avoid !important;
        }

        @page {
            size: A4 portrait !important;
            margin: 12mm !important;
        }
    }
`;

export const GenericTable = ({
    open,
    columns,
    rows = [],
    setOpen,
    userType,
    tabStatus,
    handleSubmit,
    labUserCheck,
    dispatchLocations,
    getRowDetailsApi
}: any) => {
    const [containerRows, setContainerRows] = useState<any[]>([]);
    const [packageRows, setPackageRows] = useState<any[]>([]);
    const [bottleGroupRows, setBottleGroupRows] = useState<any[]>([]);
    const [expandedBottleGroups, setExpandedBottleGroups] = useState<Record<string | number, boolean>>({});
    const [localRows, setLocalRows] = useState<any>({ ...rows });
    const createUnfulfilledOrderRef = useRef(false);
    const [unfulfilledOrderDialogOpen, setUnfulfilledOrderDialogOpen] = useState(false);
    const [hasAnsweredUnfulfilledPrompt, setHasAnsweredUnfulfilledPrompt] = useState(false);
    const [labelPrintDialogOpen, setLabelPrintDialogOpen] = useState(false);
    const [labelPrintCopies, setLabelPrintCopies] = useState<number | ''>(1);
    const [groupPrintDialogOpen, setGroupPrintDialogOpen] = useState(false);
    const [selectedGroupPrintIndex, setSelectedGroupPrintIndex] = useState<number | ''>('');
    const [groupPrintCopies, setGroupPrintCopies] = useState<number | ''>(1);
    const [labelBarcodeDataUrl, setLabelBarcodeDataUrl] = useState('');
    const [labelQrSvg, setLabelQrSvg] = useState('');
    const [downloadAttachmentsError, setDownloadAttachmentsError] = useState('');
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [rejectError, setRejectError] = useState('');
    const [openAddContainers, setOpenAddContainers] = useState(false);
    const [containerList, setContainerList] = useState<any[]>([]);
    const [addContainerType, setAddContainerType] = useState('');
    const [isAddingItem, setIsAddingItem] = useState(false);
    const [qualityAndPackingItems, setQualityAndPackingItems] = useState<any[]>([]);
    const [containerDialogOpen, setContainerDialogOpen] = useState(false);
    const [selectedQuoteForContainers, setSelectedQuoteForContainers] = useState<any>(null);
    const [message, setMessage] = useState<{
        open: boolean;
        text: string;
        type: AlertColor;
    }>({
        open: false,
        text: '',
        type: 'info',
    });

    const handlePlaceOrderForGroup = (group: any) => {
        const reference = group?.quoteAnalysisReference;
        const quoteNumber = reference?.analysisTests?.[0]?.quoteNumber || '';

        setSelectedQuoteForContainers({
            id: reference?.quoteID,
            quoteNumber,
            quoteAnalysisReference: reference
        });
        setContainerDialogOpen(true);
    };

    const handleAddContainersOpen = (type: string) => {
        if ((type === 'container' || type === 'group') && !canEditRequestedOrder) {
            return;
        }
        setAddContainerType(type);
        setOpenAddContainers(true);
    };

    const handleAddContainersClose = () => {
        setOpenAddContainers(false);
        setAddContainerType('');
    };

    const handleAddContainer = async (payload: any) => {
        if (!canEditRequestedOrder || isAddingItem) return false;
        setIsAddingItem(true);
        let errorText = 'Failed to save draft';
        try {
            const draftResponse = await updateOrderApi(getOrderPayload(rows?.status));
            if (draftResponse?.status !== 200) throw new Error(errorText);

            const isContainerItem = addContainerType === 'container' || addContainerType === 'group';
            errorText = isContainerItem ? 'Failed to add container' : 'Failed to add package';
            const apiCall = isContainerItem ? addContainerToBottleOrder : addPackageToBottleOrder;
            const response = await apiCall(payload);
            if (response?.status !== 200) throw new Error(errorText);

            setOpenAddContainers(false);
            setMessage({
                type: 'success',
                text: isContainerItem ? 'Container added successfully' : 'Package added successfully',
                open: true
            });
            getRowDetailsApi(localRows?.id);
            return true;
        } catch (error) {
            setMessage({
                type: "error",
                text: errorText,
                open: true
            });
            return false;
        } finally {
            setIsAddingItem(false);
        }
    };

    useEffect(() => {
        containerApiCall();
        qualityAndPackingApiCall();
    }, []);

    const containerApiCall = async () => {
        try {
            await getAllContainers().then((res: any) => {
                if (res.status === 200) {
                    setContainerList(res.data);
                }
            }).catch((error) => {
                setContainerList([]);
            });
        } catch (err) {
            setContainerList([]);
        }
    }

    const qualityAndPackingApiCall = async () => {
        try {
            await getQualityAndPackingItems().then((res: any) => {
                if (res.status === 200) {
                    setQualityAndPackingItems(res.data);
                }
            }).catch((error) => {
                setQualityAndPackingItems([]);
            });
        } catch (err) {
            setQualityAndPackingItems([]);
        }
    }

    const commentOptions = [
        'Insufficient stock',
        'Inventory mismatch',
        'Item discontinued'
    ];

    const dispatchOffices = dispatchLocations.length > 0 ? dispatchLocations : [
        'Sydney',
        'Melbourne',
        'Brisbane',
        'Perth',
        'Adelaide'
    ];

    const getDispatchOfficeLabel = (officeValue: any) => {
        const selectedOffice = dispatchOffices.find((office: any) => {
            if (typeof office === 'string') {
                return office === officeValue;
            }

            return office?.id === officeValue || office?.name === officeValue;
        });

        if (typeof selectedOffice === 'string') {
            return selectedOffice;
        }

        return selectedOffice?.name || rows?.despatchLocation || officeValue || '-';
    };

    const getCleanText = (...values: any[]) => {
        for (const value of values) {
            if (value === undefined || value === null) {
                continue;
            }

            const text = String(value).replace(/\s+/g, ' ').trim();
            if (text && text !== '-') {
                return text;
            }
        }

        return '';
    };

    const getNestedBottleGroupItemLabel = (item: any) => {
        const name = getCleanText(
            item?.containerName,
            item?.packageName,
            item?.name,
            item?.itemName,
            item?.container?.name,
            item?.package?.name
        );
        const description = getCleanText(item?.containerDesc, item?.packageDesc);

        if (!name) {
            return '';
        }

        return description ? `${name} (${description})` : name;
    };

    const resolveBottleGroupName = (group: any, rowIndex?: number) => {
        const directName = getCleanText(
            group?.name,
            group?.containerName,
            group?.groupName,
            group?.bottleGroupName,
            group?.packageName,
            group?.itemName,
            group?.container?.name,
            group?.package?.name,
            group?.orderedContainers?.[0]?.containerName,
            group?.orderedContainers?.[0]?.name,
            group?.orderedContainers?.[0]?.container?.name,
            group?.orderedPackages?.[0]?.packageName,
            group?.orderedPackages?.[0]?.containerName,
            group?.orderedPackages?.[0]?.name,
            group?.orderedPackages?.[0]?.package?.name
        );

        if (directName) {
            return directName;
        }

        const nestedItems = [
            ...(Array.isArray(group?.orderedContainers) ? group.orderedContainers : []),
            ...(Array.isArray(group?.orderedPackages) ? group.orderedPackages : [])
        ];
        const nestedLabels = nestedItems
            .map((item: any) => getNestedBottleGroupItemLabel(item))
            .filter(Boolean);

        if (nestedLabels.length > 0) {
            return nestedLabels.length > 1
                ? `${nestedLabels[0]} +${nestedLabels.length - 1} more`
                : nestedLabels[0];
        }

        if (group?.id !== undefined && group?.id !== null && `${group.id}`.trim() !== '') {
            return `Bottle Group #${group.id}`;
        }

        return `Bottle Group #${(rowIndex ?? 0) + 1}`;
    };

    const mapBottleGroupRow = (item: any, rowIndex?: number) => ({
        ...item,
        name: resolveBottleGroupName(item, rowIndex),
        containerName: resolveBottleGroupName(item, rowIndex),
        fulfilledQuantity:
            (item.fulfilledQuantity !== undefined && item.fulfilledQuantity !== null && item.fulfilledQuantity !== '')
                ? item.fulfilledQuantity
                : '',
        isCompleted: item.isFulfilled || false,
        orderedContainers: Array.isArray(item?.orderedContainers) ? item.orderedContainers : [],
        orderedPackages: Array.isArray(item?.orderedPackages) ? item.orderedPackages.map((packageItem: any) => ({
            ...packageItem,
            containerName: packageItem.packageName || packageItem.containerName
        })) : [],
    });

    const getItemDisplayName = (item: any) => {
        const name = item?.containerName || '-';
        const description = item?.containerDesc || item?.packageDesc || '';

        return description ? `${name} (${description})` : name;
    };

    const isRowEditable = (row: any) => userType === 'Internal' && !row.isCompleted && rows?.status === 2;
    const canEditRequestedOrder = userType === 'Internal' &&
        ((rows?.status === 1 && tabStatus === 1) || (rows?.status === 2 && tabStatus === 2)) &&
        !isAddingItem;
    const canEditRequestedQuantity = (row: any) => canEditRequestedOrder && !row.isCompleted;

    const handleItemDelete = async (idx: number, isContainer: boolean) => {
        const items = isContainer ? containerRows : packageRows;
        const item = items[idx];

        if (!canEditRequestedQuantity(item) || isAddingItem) return;

        const orderId = localRows?.id ?? rows?.id;
        const itemId = isContainer
            ? item?.id ?? item?.containerID
            : item?.id ?? item?.packageID ?? item?.PackageId;

        if (orderId === undefined || orderId === null || itemId === undefined || itemId === null) {
            setMessage({
                type: 'error',
                text: `Unable to identify the ${isContainer ? 'container' : 'package'} to delete`,
                open: true
            });
            return;
        }

        setIsAddingItem(true);

        try {            
            const response = isContainer
                ? await deleteContainerItem(orderId, 0, itemId)
                : await deletePackageItem(orderId, itemId);

            if (response?.status !== 200) {
                setMessage({
                    type: 'error',
                    text: `Failed to delete ${isContainer ? 'container' : 'package'}`,
                    open: true
                });
                return;
            } else {
                setMessage({
                    type: 'success',
                    text: `${isContainer ? 'Container' : 'Package'} deleted successfully`,
                    open: true
                });
                getRowDetailsApi(orderId);
            }
        } catch (error) {
            setMessage({
                type: 'error',
                text: `Error deleting ${isContainer ? 'container' : 'package'}`,
                open: true
            });
        } finally {
            setIsAddingItem(false);
        }
    };

    const renderItemDeleteAction = (item: any, idx: number, isContainer: boolean) => (
        <TableCell className="print-hide" align="center" sx={{ padding: '8px', width: 48 }}>
            <Tooltip title={isContainer ? 'Delete container' : 'Delete package'}>
                <span>
                    <IconButton
                        size="small"
                        color="error"
                        aria-label={isContainer ? 'Delete container' : 'Delete package'}
                        disabled={!canEditRequestedQuantity(item)}
                        onClick={() => handleItemDelete(idx, isContainer)}
                    >
                        <DeleteOutline fontSize="small" />
                    </IconButton>
                </span>
            </Tooltip>
        </TableCell>
    );

    const bottleGroupColumns = [
        ...columns
            .filter(
                (col: any) =>
                    col.field !== 'select' &&
                    col.field !== 'multiplier' &&
                    col.headerName !== 'Unit Type'
            )
            .map((col: any) => ({
                ...col,
                headerName:
                    col.field === 'containerName' || col.field === 'name'
                        ? 'Name'
                        : col.headerName,
            })),
        ...columns.filter((col: any) => col.field === 'select'),
        {
            field: 'action',
            headerName: 'Action',
            minWidth: 30,
        },
    ];

    useEffect(() => {
        const expanded: Record<string | number, boolean> = {};

        bottleGroupRows.forEach((group, idx) => {
            const key = group.id ?? idx;
            expanded[key] = true;
        });

        setExpandedBottleGroups(expanded);
    }, [bottleGroupRows]);

    const toggleBottleGroupExpanded = (groupKey: string | number) => {
        setExpandedBottleGroups(prev => ({
            ...prev,
            [groupKey]: !prev[groupKey]
        }));
    };

    const handleBottleGroupDelete = async (container: any) => {
        if (!canEditRequestedQuantity(container)) return;

        const containerId = container?.id ?? container?.containerID;
        const isSelectedContainer = (item: any) => {
            const itemId = item?.id ?? item?.containerID;
            return (
                item === container ||
                (containerId !== undefined &&
                    containerId !== null &&
                    itemId !== undefined &&
                    itemId !== null &&
                    String(itemId) === String(containerId))
            );
        };

        const containsContainer = (items: any[]): boolean =>
            items.some(item =>
                isSelectedContainer(item) ||
                (Array.isArray(item?.orderedContainers) &&
                    containsContainer(item.orderedContainers))
            );

        const owningGroup = bottleGroupRows.find(group =>
            containsContainer(
                Array.isArray(group.orderedContainers)
                    ? group.orderedContainers
                    : []
            )
        );

        if (!owningGroup) return;

        const orderId = localRows?.id ?? rows?.id;
        const groupId = owningGroup?.id;

        try {
            const response = await deleteContainerItem(orderId, groupId, containerId);
            if (response?.status === 200) {
                getRowDetailsApi(localRows?.id);
                setMessage({
                    type: 'success',
                    text: 'Container deleted successfully',
                    open: true
                });
            } else {
                setMessage({
                    type: 'error',
                    text: 'Failed to delete container',
                    open: true
                });
            }
        } catch (error) {
            setMessage({
                type: 'error',
                text: 'Error deleting container',
                open: true
            });
        }

    };

    const renderReadonlyTreeItems = (container: any, typeLabel: string, parentKey: string | number) => {
        const items = Array.isArray(container?.orderedContainers)
            ? container.orderedContainers
            : [];

        if (!items.length) {
            return null;
        }

        return items.map((item, nestedIndex) => (
            <TableRow key={`${parentKey}-${typeLabel}-${item.id ?? nestedIndex}`}>
                {bottleGroupColumns.map((col: any, colIndex: any) => {
                    if (col.field === 'containerName' || col.field === 'name') {
                        return (
                            <TableCell key={col.field} sx={{ padding: '8px 8px 8px 32px', backgroundColor: '#fafafa', minWidth: col.minWidth, whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
                                <Typography
                                    variant="body2"
                                    noWrap
                                    title={getItemDisplayName(item)}
                                    sx={{ color: '#000', maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'anywhere' }}
                                >
                                    {getItemDisplayName(item)}
                                </Typography>
                            </TableCell>
                        );
                    }
                    // requestedQuantity section mapping the multiplier value to the requestedQuantity column for display
                    if (col.field === 'requestedQuantity') {
                        const multiplier = Number(item?.multiplier ?? 1);

                        return (
                            <TableCell
                                key={col.field}
                                sx={{
                                    padding: '8px',
                                    backgroundColor: '#fafafa',
                                    minWidth: col.minWidth
                                }}
                            >
                                <Box className="print-hide">
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            border: '1px solid rgba(0,0,0,0.23)',
                                            borderRadius: 1,
                                            overflow: 'hidden',
                                            height: 32,
                                            width: 'fit-content'
                                        }}
                                    >
                                        {/* MINUS */}
                                        <IconButton
                                            size="small"
                                            disabled={!canEditRequestedQuantity(item) || multiplier <= 1}
                                            onClick={() =>
                                                handleBottleGroupCellChange(
                                                    item.id,
                                                    'multiplier',
                                                    Math.max(1, multiplier - 1)
                                                )
                                            }
                                            sx={{
                                                borderRadius: 0,
                                                height: '100%',
                                                width: 24,
                                                p: 0,
                                                minWidth: 0
                                            }}
                                        >
                                            <Remove sx={{ fontSize: 14 }} />
                                        </IconButton>

                                        {/* VALUE */}
                                        <input
                                            type="number"
                                            value={multiplier}
                                            min={1}
                                            max={6}
                                            disabled={!canEditRequestedQuantity(item)}
                                            onChange={(e) => {
                                                const val = Number(e.target.value);

                                                if (
                                                    Number.isFinite(val) &&
                                                    val >= 1 &&
                                                    val <= 6
                                                ) {
                                                    handleBottleGroupCellChange(
                                                        item.id,
                                                        'multiplier',
                                                        val
                                                    );
                                                }
                                            }}
                                            style={{
                                                width: 35,
                                                textAlign: 'center',
                                                border: 'none',
                                                borderLeft: '1px solid rgba(0,0,0,0.12)',
                                                borderRight: '1px solid rgba(0,0,0,0.12)',
                                                outline: 'none',
                                                fontSize: '12px',
                                                height: '100%',
                                                padding: 0,
                                                WebkitAppearance: 'none',
                                                MozAppearance: 'textfield'
                                            }}
                                        />

                                        {/* PLUS */}
                                        <IconButton
                                            size="small"
                                            disabled={!canEditRequestedQuantity(item) || multiplier >= 6}
                                            onClick={() =>
                                                handleBottleGroupCellChange(
                                                    item.id,
                                                    'multiplier',
                                                    Math.min(6, multiplier + 1)
                                                )
                                            }
                                            sx={{
                                                borderRadius: 0,
                                                height: '100%',
                                                width: 24,
                                                p: 0,
                                                minWidth: 0
                                            }}
                                        >
                                            <Add sx={{ fontSize: 14 }} />
                                        </IconButton>
                                    </Box>
                                </Box>

                                {/* PRINT */}
                                <Box
                                    className="print-status-text"
                                    sx={{
                                        display: 'none',
                                        '@media print': {
                                            display: 'block !important'
                                        }
                                    }}
                                >
                                    <Typography variant="body2">
                                        {multiplier}
                                    </Typography>
                                </Box>
                            </TableCell>
                        );
                    }


                    if (col.field === 'fulfilledQuantity') {
                        return (
                            <TableCell key={col.field} sx={{ padding: '8px', backgroundColor: '#fafafa', minWidth: col.minWidth }}>
                                {item?.multiplier ?? '-'}
                            </TableCell>
                        );
                    }

                    if (col.field === 'comments') {
                        return (
                            <TableCell key={col.field} sx={{ padding: '8px', backgroundColor: '#fafafa', minWidth: col.minWidth }}>
                                {item?.comments || '-'}
                            </TableCell>
                        );
                    }

                    if (col.field === 'action') {
                        return (
                            <TableCell className="print-hide" key={col.field} sx={{ padding: '8px', backgroundColor: '#fafafa', minWidth: col.minWidth }}>
                                <Tooltip title="Delete">
                                    <span>
                                        <IconButton
                                            size="small"
                                            color="error"
                                            aria-label="Delete container"
                                            disabled={!canEditRequestedQuantity(item)}
                                            onClick={() => handleBottleGroupDelete(item)}
                                            sx={{ ml: 0.5 }}
                                        >
                                            <DeleteOutline fontSize="small" />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                            </TableCell>
                        );
                    }

                    return (
                        <TableCell key={col.field} sx={{ padding: '8px', backgroundColor: '#fafafa', minWidth: col.minWidth }}>
                            -
                        </TableCell>
                    );
                })}
            </TableRow>
        ));
    };

    useEffect(() => {
        // Map orderedContainers
        if (rows && Array.isArray(rows.orderedContainers)) {
            setContainerRows(rows.orderedContainers.map((item: any) => ({
                ...item,
                fulfilledQuantity:
                    (item.fulfilledQuantity !== undefined && item.fulfilledQuantity !== null && item.fulfilledQuantity !== '')
                        ? item.fulfilledQuantity
                        : '',
                isCompleted: item.isFulfilled || false,
            })));
        } else {
            setContainerRows([]);
        }

        // Map orderedPackages
        if (rows && Array.isArray(rows.orderedPackages)) {
            setPackageRows(rows.orderedPackages.map((item: any) => ({
                ...item,
                containerName: item.packageName, // Map packageName to containerName for display
                containerDesc: item.packageDesc || item.containerDesc,
                fulfilledQuantity:
                    (item.fulfilledQuantity !== undefined && item.fulfilledQuantity !== null && item.fulfilledQuantity !== '')
                        ? item.fulfilledQuantity
                        : '',
                isCompleted: item.isFulfilled || false,
            })));
        } else {
            setPackageRows([]);
        }

        if (rows && Array.isArray(rows.bottleGroups)) {
            setBottleGroupRows(rows.bottleGroups.map((item: any, index: number) => mapBottleGroupRow(item, index)));
        } else {
            setBottleGroupRows([]);
        }

        setExpandedBottleGroups({});

        setLocalRows({ ...rows });

        if (open) {
            createUnfulfilledOrderRef.current = false;
            setUnfulfilledOrderDialogOpen(false);
            setHasAnsweredUnfulfilledPrompt(false);
            setLabelPrintDialogOpen(false);
            setLabelPrintCopies(1);
            setGroupPrintDialogOpen(false);
            setSelectedGroupPrintIndex('');
            setGroupPrintCopies(1);
        }
    }, [rows, open]);

    const [fulfilledChanged, setFulfilledChanged] = useState(false);

    const handleCellChange = (idx: number, field: string, value: any, isContainer: boolean) => {
        // Only for fulfilledQuantity and comments
        const updateRows = (rows, setRows) => {
            const updated = [...rows];
            if (field === 'fulfilledQuantity') {
                let newValue = value;
                // 7. If previously comments existed for > requested, but now less, reset comments
                if (Number(newValue) <= Number(updated[idx].requestedQuantity) && updated[idx].comments) {
                    updated[idx].comments = '';
                }
                updated[idx][field] = newValue;

                // Trigger comments validation immediately
                const commentsRequired = newValue !== '' && Number(newValue) !== Number(updated[idx].requestedQuantity);
                updated[idx].showCommentsError = !updated[idx].isCompleted && commentsRequired && !(updated[idx].comments && updated[idx].comments.trim());

                // Track that fulfilledQuantity has changed at least once
                setFulfilledChanged(true);
            } else if (field === 'comments') {
                updated[idx][field] = value;
                // Re-validate comments if changed
                const fulfilledValue = updated[idx].fulfilledQuantity ?? '';
                const commentsRequired = fulfilledValue !== '' && Number(fulfilledValue) !== Number(updated[idx].requestedQuantity);
                updated[idx].showCommentsError = !updated[idx].isCompleted && commentsRequired && !(value && value.trim());
            } else {
                updated[idx][field] = value;
            }
            return updated;
        };
        if (isContainer) {
            setContainerRows(prev => updateRows(prev, setContainerRows));
        } else {
            setPackageRows(prev => updateRows(prev, setPackageRows));
        }
    };

    const handleBottleGroupCellChange = (
        idx: number,
        field: string,
        value: any
    ) => {
        setBottleGroupRows(prev => {
            const updated = [...prev];

            if (field === 'multiplier') {
                return updated.map((row: any) => ({
                    ...row,
                    orderedContainers: row.orderedContainers?.map(
                        (container: any) => {
                            if (String(container.id) === String(idx)) {
                                return {
                                    ...container,
                                    multiplier: value
                                };
                            }
                            return container;
                        }
                    )
                }));
            }

            if (field === 'containerRequestedQuantity') {
                return updated.map((row: any) => ({
                    ...row,
                    orderedContainers: row.orderedContainers?.map(
                        (container: any) => {
                            if (String(container.id) === String(idx)) {
                                return {
                                    ...container,
                                    requestedQuantity: value
                                };
                            }
                            return container;
                        }
                    )
                }));
            }

            if (field === 'requestedQuantity') {
                updated[idx] = {
                    ...updated[idx],
                    requestedQuantity: value,
                    orderedContainers: (updated[idx].orderedContainers || []).map(
                        (container: any) => ({
                            ...container,
                            requestedQuantity: value
                        })
                    )
                };
                return updated;
            }

            if (field === 'fulfilledQuantity') {
                if (
                    Number(value) <= Number(updated[idx].requestedQuantity) &&
                    updated[idx].comments
                ) {
                    updated[idx].comments = '';
                }

                updated[idx][field] = value;
                updated[idx].orderedContainers = (updated[idx].orderedContainers || []).map(
                    (container: any) => ({
                        ...container,
                        fulfilledQuantity: value
                    })
                );

                const commentsRequired =
                    value !== '' &&
                    Number(value) !== Number(updated[idx].requestedQuantity);

                updated[idx].showCommentsError =
                    !updated[idx].isCompleted &&
                    commentsRequired &&
                    !(
                        updated[idx].comments &&
                        updated[idx].comments.trim()
                    );

                setFulfilledChanged(true);
            } else if (field === 'comments') {
                updated[idx][field] = value;

                const fulfilledValue =
                    updated[idx].fulfilledQuantity ?? '';

                const commentsRequired =
                    fulfilledValue !== '' &&
                    Number(fulfilledValue) !==
                    Number(updated[idx].requestedQuantity);

                updated[idx].showCommentsError =
                    !updated[idx].isCompleted &&
                    commentsRequired &&
                    !(value && value.trim());
            } else {
                updated[idx][field] = value;
            }

            return updated;
        });
    };

    const handleTickToggle = (idx: number, forceMapRequested = false, isContainer: boolean) => {
        // Only map requestedQuantity if fulfilledQuantity is empty (null, undefined, or '')
        const updateRows = (rows, setRows) => {
            const updated = [...rows];
            if (!updated[idx].isCompleted) {
                const nextFulfilledQuantity =
                    forceMapRequested || updated[idx].fulfilledQuantity === '' || updated[idx].fulfilledQuantity === undefined || updated[idx].fulfilledQuantity === 0
                        ? updated[idx].requestedQuantity
                        : updated[idx].fulfilledQuantity === null
                            ? ''
                            : updated[idx].fulfilledQuantity;
                const shouldClearComments = Number(nextFulfilledQuantity) === Number(updated[idx].requestedQuantity);

                updated[idx] = {
                    ...updated[idx],
                    isCompleted: true,
                    isFulfilled: true,
                    fulfilledQuantity: nextFulfilledQuantity,
                    comments: shouldClearComments ? '' : updated[idx].comments,
                    fulfilledDisabled: true,
                    showCommentsError: false // Hide comments error when tick mark is clicked
                };
            } else {
                updated[idx] = {
                    ...updated[idx],
                    isCompleted: false,
                    isFulfilled: false,
                    fulfilledDisabled: false
                };
            }
            return updated;
        };
        if (isContainer) {
            setContainerRows(prev => updateRows(prev, setContainerRows));
        } else {
            setPackageRows(prev => updateRows(prev, setPackageRows));
        }
    };

    const handleBottleGroupTickToggle = (idx: number, forceMapRequested = false) => {
        setBottleGroupRows(prev => {
            const updated = [...prev];

            if (!updated[idx].isCompleted) {
                const nextFulfilledQuantity =
                    forceMapRequested || updated[idx].fulfilledQuantity === '' || updated[idx].fulfilledQuantity === undefined || updated[idx].fulfilledQuantity === 0
                        ? updated[idx].requestedQuantity
                        : updated[idx].fulfilledQuantity === null
                            ? ''
                            : updated[idx].fulfilledQuantity;
                const shouldClearComments = Number(nextFulfilledQuantity) === Number(updated[idx].requestedQuantity);

                updated[idx] = {
                    ...updated[idx],
                    isCompleted: true,
                    isFulfilled: true,
                    fulfilledQuantity: nextFulfilledQuantity,
                    comments: shouldClearComments ? '' : updated[idx].comments,
                    fulfilledDisabled: true,
                    showCommentsError: false
                };
            } else {
                updated[idx] = {
                    ...updated[idx],
                    isCompleted: false,
                    isFulfilled: false,
                    fulfilledDisabled: false
                };
            }

            return updated;
        });
    };

    const handlePrint = () => {
        const styleSheet = document.createElement('style');
        styleSheet.type = 'text/css';
        styleSheet.innerText = printStyles;
        document.head.appendChild(styleSheet);

        const originalTitle = document.title;
        document.title = `Order Details - ${rows?.id || 'Order'}`;

        window.focus();
        setTimeout(() => {
            window.print();

            setTimeout(() => {
                document.head.removeChild(styleSheet);
                document.title = originalTitle;
            }, 100);
        }, 500);
    };

    const handlePrintLabels = () => {
        const copies = Number(labelPrintCopies);

        if (!copies || Number.isNaN(copies) || copies < 1) {
            setLabelPrintCopies(1);
            return;
        }

        const printLabels = () => {
            setLabelPrintDialogOpen(false);

            const startPrint = () => {
                const styleSheet = document.createElement('style');
                styleSheet.type = 'text/css';
                styleSheet.innerText = labelPrintStyles;
                document.head.appendChild(styleSheet);

                const originalTitle = document.title;
                document.title = `Recipient Labels - ${rows?.id || 'Order'}`;

                window.focus();
                window.print();

                setTimeout(() => {
                    document.head.removeChild(styleSheet);
                    document.title = originalTitle;
                }, 100);
            };

            requestAnimationFrame(() => requestAnimationFrame(startPrint));
        };

        if (labelQrSvg) {
            printLabels();
        }
    };

    const handlePrintGroups = () => {
        const copies = Number(groupPrintCopies);

        if (selectedGroupPrintIndex === '' || !copies || Number.isNaN(copies) || copies < 1) {
            return;
        }

        setGroupPrintDialogOpen(false);

        const styleSheet = document.createElement('style');
        styleSheet.type = 'text/css';
        styleSheet.innerText = groupPrintStyles;
        document.head.appendChild(styleSheet);

        const originalTitle = document.title;
        document.title = `Bottle Group - ${rows?.id || 'Order'}`;

        window.focus();
        setTimeout(() => {
            window.print();

            setTimeout(() => {
                document.head.removeChild(styleSheet);
                document.title = originalTitle;
            }, 100);
        }, 300);
    };

    const handleDownloadAttachments = async () => {
        if (!rows?.id) {
            return;
        }

        setDownloadAttachmentsError('');

        try {
            const response = await downloadOrderAttachment(rows.id);

            if (response?.status !== 200 || !response?.data) {
                const message = response?.data || 'Failed to download attachments.';
                setDownloadAttachmentsError(message);
                return;
            }

            const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
            const downloadLink = document.createElement('a');
            downloadLink.href = downloadUrl;
            downloadLink.download = `Order-${rows.id}-Attachments.zip`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            downloadLink.remove();
            window.URL.revokeObjectURL(downloadUrl);
        } catch (error: any) {
            const message = error?.response?.data || error?.message || 'Failed to download attachments.';
            setDownloadAttachmentsError(message);
        }
    };

    const labelPageCount = Number(labelPrintCopies) > 0 ? Number(labelPrintCopies) : 1;
    const labelPages = Array.from({ length: labelPageCount }, (_, index) => index + 1);
    const selectedGroupForPrint = selectedGroupPrintIndex === '' ? null : bottleGroupRows[Number(selectedGroupPrintIndex)];
    const groupPrintItems = selectedGroupForPrint
        ? [
            ...(Array.isArray(selectedGroupForPrint.orderedContainers) ? selectedGroupForPrint.orderedContainers : []),
            ...(Array.isArray(selectedGroupForPrint.orderedPackages) ? selectedGroupForPrint.orderedPackages : [])
        ]
        : [];
    const groupPageCount = Number(groupPrintCopies) > 0 ? Number(groupPrintCopies) : 1;
    const groupPages = Array.from({ length: groupPageCount }, (_, index) => index + 1);
    const labelCourierInfo = localRows?.courierInfo || rows?.courierInfo || '-';
    const labelTrackingNumber = localRows?.trackingID || rows?.trackingID || '-';
    const labelDeliveryInstructions = rows?.orderRecipient?.deliveryInstruction || rows?.orderRecipient?.deliveryInstructions || '-';
    const labelOrderNumber = String(rows?.id || '-');
    const labelOrderName = rows?.orderName || `${rows?.orderRecipient?.name || 'Customer'}'s Order`;
    const labelRecipientName = rows?.orderRecipient?.name || rows?.orderName || '-';
    const labelContactName = rows?.orderRecipient?.contactName || '-';
    const labelRecipientEmail = rows?.orderRecipient?.emailId || rows?.orderRecipient?.email || '-';
    const labelRecipientPhone = rows?.orderRecipient?.contactNo || '-';
    const labelExpectedDate = rows?.orderRecipient?.date
        ? moment(rows.orderRecipient.date).format('YYYY-MM-DD')
        : '-';
    const labelSuburb = rows?.orderRecipient?.suburb || '-';
    const labelStreet = rows?.orderRecipient?.street || '-';
    const labelState = rows?.orderRecipient?.state || '-';
    const labelCountry = rows?.orderRecipient?.country || '-';
    const labelPostalCode = rows?.orderRecipient?.postalCode || '-';

    const compactQrText = (value: any, maxLength: number) => {
        const normalized = String(value ?? '-')
            .replace(/\s+/g, ' ')
            .trim();

        return normalized.length > maxLength
            ? `${normalized.slice(0, maxLength - 3)}...`
            : normalized;
    };

    const labelQrPayload = useMemo(() => ([
        `Order name: ${compactQrText(labelOrderName, 80)}`,
        `Business Name: ${compactQrText(labelRecipientName, 60)}`,
        `Contact Name: ${compactQrText(labelContactName, 60)}`,
        `Email: ${compactQrText(labelRecipientEmail, 90)}`,
        `Contact: ${compactQrText(labelRecipientPhone, 30)}`,
        `Expected date: ${compactQrText(labelExpectedDate, 20)}`,
        '',
        'Address:',
        `Suburb: ${compactQrText(labelSuburb, 60)}`,
        `Street: ${compactQrText(labelStreet, 90)}`,
        `State: ${compactQrText(labelState, 60)}`,
        `Country: ${compactQrText(labelCountry, 50)}`,
        `Postal code: ${compactQrText(labelPostalCode, 30)}`,
        '',
        `Courier company: ${compactQrText(labelCourierInfo, 70)}`,
        `Tracking number: ${compactQrText(labelTrackingNumber, 70)}`
    ].join('\n')), [
        labelOrderName,
        labelRecipientName,
        labelContactName,
        labelRecipientEmail,
        labelRecipientPhone,
        labelExpectedDate,
        labelSuburb,
        labelStreet,
        labelState,
        labelCountry,
        labelPostalCode,
        labelCourierInfo,
        labelTrackingNumber
    ]);

    useEffect(() => {
        try {
            const canvas = document.createElement('canvas');
            JsBarcode(canvas, labelOrderNumber, {
                format: 'CODE128',
                displayValue: false,
                margin: 0,
                width: 4,
                height: 65
            });
            setLabelBarcodeDataUrl(canvas.toDataURL('image/png'));
        } catch {
            setLabelBarcodeDataUrl('');
        }
    }, [labelOrderNumber]);

    useEffect(() => {
        let active = true;

        setLabelQrSvg('');
        generateQrSvg(labelQrPayload, {
            type: 'svg',
            errorCorrectionLevel: 'L',
            margin: 2,
            width: 360,
            color: {
                dark: '#000000',
                light: '#FFFFFF'
            }
        }).then(svg => {
            if (active) {
                setLabelQrSvg(svg);
            }
        }).catch(error => {
            // console.error('QR code generation failed:', error);
        });

        return () => {
            active = false;
        };
    }, [labelQrPayload, labelPageCount]);

    const minExpectedDate = moment().format('YYYY-MM-DD');
    const isExpectedDateMissing = rows?.status === 1 && !`${localRows?.orderRecipient?.date || ''}`.trim();
    const isExpectedDateInPast = rows?.status === 1 && !!localRows?.orderRecipient?.date && moment(localRows.orderRecipient.date, 'YYYY-MM-DD', true).isBefore(moment().startOf('day'));

    const shouldPromptForUnfulfilledOrder = rows?.status === 2 && fulfilledChanged && (
        [...containerRows, ...packageRows, ...bottleGroupRows].some(
            r => r.fulfilledQuantity !== null && r.fulfilledQuantity !== '' && Number(r.fulfilledQuantity) < Number(r.requestedQuantity)
        )
    );

    useEffect(() => {
        if (!shouldPromptForUnfulfilledOrder) {
            setUnfulfilledOrderDialogOpen(false);
            setHasAnsweredUnfulfilledPrompt(false);
            createUnfulfilledOrderRef.current = false;
            return;
        }

        // if (!hasAnsweredUnfulfilledPrompt) {
        //     setUnfulfilledOrderDialogOpen(true);
        // }
    }, [shouldPromptForUnfulfilledOrder, hasAnsweredUnfulfilledPrompt]);

    const getOrderPayload = (statusUpdate: any) => {
        const orderedContainers = containerRows.map(row => ({
            ...row,
            fulfilledQuantity: row.fulfilledQuantity,
            isFulfilled: row.isCompleted
        }));

        const orderedPackages = packageRows.map(row => ({
            ...row,
            fulfilledQuantity: row.fulfilledQuantity,
            isFulfilled: row.isCompleted
        }));

        const bottleGroups = bottleGroupRows.map(row => ({
            ...row,
            fulfilledQuantity: row.fulfilledQuantity,
            isFulfilled: row.isCompleted,
            orderedContainers: Array.isArray(row.orderedContainers) ? row.orderedContainers : [],
            orderedPackages: Array.isArray(row.orderedPackages) ? row.orderedPackages : []
        }));

        return {
            ...localRows,
            datePacked: new Date(),
            orderedContainers,
            orderedPackages,
            bottleGroups,
            cloneForRemainderItems: createUnfulfilledOrderRef.current,
            status: statusUpdate ? statusUpdate : ""
        };
    };

    const handleConfirm = (statusUpdate: any, actionType: any, previousStatus: any) => {
        if (isAddingItem) return;
        handleSubmit(getOrderPayload(statusUpdate), statusUpdate, actionType, previousStatus);
        createUnfulfilledOrderRef.current = false;
        setOpen(false);
    };

    const getDeliveryTypeBadge = () => {
        return (
            <Chip
                label={rows?.needsDelivery ? 'Delivery' : 'Pickup'}
                color={rows?.needsDelivery ? 'primary' : 'secondary'}
                size="small"
                sx={{ ml: 1 }}
            />
        );
    };

    const isConfirmDisabled = () => {
        // 1. Status 1: Dispatch Office required
        if (rows?.status === 1) {
            return !localRows.despatchLocationID || isExpectedDateMissing || isExpectedDateInPast;
        }
        // 2. Status 2: Only enable packed button if all tick marks are checked
        if (rows?.status === 2) {
            const allRows = [...containerRows, ...packageRows, ...bottleGroupRows];
            if (allRows.some(r => !r.isCompleted)) {
                return true;
            }
            // Keep comments validation logic if needed
            if (allRows.some(r => (Number(r.fulfilledQuantity) === 0 || r.fulfilledQuantity === '') && !(r.comments && r.comments.trim()))) {
                return true;
            }
            if (allRows.some(r => Number(r.fulfilledQuantity) !== Number(r.requestedQuantity) && !(r.comments && r.comments.trim()))) {
                return true;
            }
        }
        // 3. Status 3: Delivery or Pickup
        if (rows?.status === 3) {
            if (rows?.needsDelivery) {
                return !localRows.courierInfo || !localRows.trackingID;
            } else {
                return !localRows.pickedUpOn;
            }
        }
        // 4. Status 4: (optional, keep as is or add logic)
        return false;
    };

    const handleReject = () => {
        setConfirmOpen(true);
    };

    const handleRejectConfirm = () => {
        const comments = localRows.comments?.trim();

        if (!comments) {
            setRejectError('Please enter the reason for rejecting this order.');
            return;
        }

        setRejectError('');
        handleConfirm(5, 'reject', 5);
        setConfirmOpen(false);
    };

    const containerPermissions = Array.isArray(labUserCheck?.Permission) ? labUserCheck.Permission : [];
    const hasViewContainerPermission = containerPermissions.length === 1 && containerPermissions.includes('ViewContainerOrder');
    const loadContainers = (addContainerType === 'container' || addContainerType === 'group') ? containerList : qualityAndPackingItems;

    return (
        <>
            <Dialog
                open={open}
                onClose={() => {
                    setOpen(false);
                }}
                fullWidth
                maxWidth="lg"
                PaperProps={{ style: { width: '100%', maxWidth: '100%' } }}
            >
                <div className="print-area-show">
                    <DialogTitle sx={{ pb: 1 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Typography variant="h6"
                                    component="span"
                                    sx={{
                                        fontWeight: 600,
                                        '@media print': {
                                            color: '#000 !important',
                                        },
                                    }}
                                >
                                    Order #{rows?.id} Details {rows?.associatedOrderId !== null && `(Associated with Order #${rows?.associatedOrderId})`}
                                </Typography>
                                {getDeliveryTypeBadge()}
                            </Box>
                            {userType === 'Internal' && (
                                <Box className="print-button-container" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        onClick={() => setLabelPrintDialogOpen(true)}
                                        sx={{ textTransform: 'none' }}
                                    >
                                        Print Label
                                    </Button>
                                    {bottleGroupRows.length > 0 && (
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            onClick={() => setGroupPrintDialogOpen(true)}
                                            sx={{ textTransform: 'none' }}
                                        >
                                            Print Groups
                                        </Button>
                                    )}
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        onClick={handlePrint}
                                        sx={{ minWidth: 0, padding: '6px' }}
                                    >
                                        Print Consignment
                                    </Button>
                                </Box>
                            )}
                        </Box>
                    </DialogTitle>
                </div>
                <DialogContent sx={{ pt: 1 }}>
                    <Box className="label-print-root" sx={{ display: 'none' }}>
                        {labelPages.map((pageNumber) => (
                            <Box key={pageNumber} className="label-print-page">
                                <Box className="label-print-card">
                                    <Box className="label-top-strip" />
                                    <Box className="label-header">
                                        <Box className="label-company-block">
                                            <img src={ETLogo} alt="ET Logo" className="label-logo" />
                                        </Box>
                                        <Box className="label-top-barcode-block">
                                            {labelBarcodeDataUrl ? (
                                                <img src={labelBarcodeDataUrl} alt="Order barcode" className="label-top-barcode-image" />
                                            ) : (
                                                <Typography className="label-fallback">Barcode unavailable</Typography>
                                            )}
                                            {/* <Typography className="label-top-order-line">Order No. {labelOrderNumber}</Typography> */}
                                        </Box>
                                    </Box>

                                    <Box className="label-main">
                                        <Box className="label-main-left">
                                            <Box className="label-section-card">
                                                <Typography className="label-section-title">Delivery Address</Typography>
                                                <Typography className="label-kv-row"><span className="label-kv-key">Business Name:</span> {labelRecipientName}</Typography>
                                                <Typography className="label-kv-row"><span className="label-kv-key">Street:</span> {labelStreet}</Typography>
                                                <Typography className="label-kv-row"><span className="label-kv-key">Suburb:</span> {labelSuburb}</Typography>
                                                <Typography className="label-kv-row"><span className="label-kv-key">State:</span> {labelState}</Typography>
                                                <Typography className="label-kv-row"><span className="label-kv-key">Country:</span> {labelCountry}</Typography>
                                                <Typography className="label-kv-row"><span className="label-kv-key">Postal Code:</span> {labelPostalCode}</Typography>
                                            </Box>

                                            <Box className="label-courier-row">
                                                <Box className="label-mini-card">
                                                    <Typography component="span" className="label-meta-label">Courier Company:</Typography>
                                                    <Typography component="span" className="label-meta-value">{labelCourierInfo}</Typography>
                                                </Box>
                                                <Box className="label-mini-card">
                                                    <Typography component="span" className="label-meta-label">Tracking Number:</Typography>
                                                    <Typography component="span" className="label-meta-value">{labelTrackingNumber}</Typography>
                                                </Box>
                                            </Box>

                                            <Box className="label-instruction-card">
                                                <Typography className="label-instruction-title">Delivery Instructions</Typography>
                                                <Typography className="label-instruction-text">{labelDeliveryInstructions}</Typography>
                                            </Box>
                                        </Box>

                                        <Box className="label-main-right">
                                            <Box className="label-section-card">
                                                <Typography className="label-section-title">Order Details</Typography>
                                                <Typography className="label-kv-row"><span className="label-kv-key">Order Name:</span> {labelOrderName}</Typography>
                                                <Typography className="label-kv-row"><span className="label-kv-key">Contact Name:</span> {labelContactName}</Typography>
                                                <Typography className="label-kv-row"><span className="label-kv-key">Contact:</span> {labelRecipientPhone}</Typography>
                                                <Typography className="label-kv-row"><span className="label-kv-key">Expected Date:</span> {labelExpectedDate}</Typography>
                                            </Box>

                                            <Box className="label-qr-card">
                                                {labelQrSvg && (
                                                    <Box
                                                        className="label-qr-svg"
                                                        aria-label="Order QR code"
                                                        dangerouslySetInnerHTML={{ __html: labelQrSvg }}
                                                    />
                                                )}
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                                <Typography className="label-print-page-number">
                                    {pageNumber}/{labelPageCount}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                    <Box className="group-print-root" sx={{ display: 'none' }}>
                        {selectedGroupForPrint && groupPages.map((pageNumber) => (
                            <Box key={pageNumber} className="group-print-page">
                                <Typography className="group-print-title">
                                    Order Name: {rows?.orderName || '-'}
                                </Typography>
                                <Typography className="group-print-subtitle">
                                    Order #{rows?.id}
                                </Typography>
                                <table className="group-print-table">
                                    <thead>
                                        <tr>
                                            <th style={{ width: 'calc(100% - 60px)' }}>Name</th>
                                            <th style={{ width: '60px' }}>Quantity</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className="group-print-parent-row">
                                            <td>{resolveBottleGroupName(selectedGroupForPrint, Number(selectedGroupPrintIndex))}</td>
                                            <td>{selectedGroupForPrint.fulfilledQuantity ?? '-'}</td>
                                        </tr>
                                        {groupPrintItems.length === 0 ? (
                                            <tr>
                                                <td colSpan={2}>No containers available</td>
                                            </tr>
                                        ) : (
                                            groupPrintItems.map((item: any, itemIndex: number) => (
                                                <tr key={item?.id ?? itemIndex}>
                                                    <td className="group-print-child-cell">{getNestedBottleGroupItemLabel(item) || getItemDisplayName(item)}</td>
                                                    <td>{item?.multiplier ?? '-'}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                                <Typography className="group-print-page-number">
                                    {pageNumber}/{groupPageCount}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                    <div className="print-area-show">
                        <Card variant="outlined" sx={{ mb: 3, borderRadius: 1 }} className="recipient-details">                        <CardContent sx={{ pb: '16px !important' }}>
                            <Typography variant="h6" gutterBottom
                                sx={{
                                    mb: 2,
                                    fontWeight: 600,
                                    '@media print': {
                                        color: '#000 !important',
                                    },
                                }}
                            >
                                <PersonIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                                Recipient Details
                            </Typography>

                            <Grid container spacing={2} className="recipient-summary-grid">
                                <Grid item xs={12} md={6}>
                                    <Box>
                                        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: 'text.primary' }}>
                                            Contact Information
                                        </Typography>
                                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                            <PersonIcon sx={{ fontSize: 18, mr: 1, mt: 0.2, color: 'text.secondary' }} />
                                            <Box sx={{ width: '100%' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
                                                    <Typography variant="body2" sx={{ width: '160px', minWidth: '160px', fontWeight: 600, flexShrink: 0 }}>
                                                        Order Name:
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ flex: 1, minWidth: 0, wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
                                                        {rows?.orderName || '-'}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
                                                    <Typography variant="body2" sx={{ width: '160px', minWidth: '160px', fontWeight: 600, flexShrink: 0 }}>
                                                        Business Name:
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ flex: 1, minWidth: 0, wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
                                                        {rows?.orderRecipient?.name || '-'}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
                                                    <Typography variant="body2" sx={{ width: '160px', minWidth: '160px', fontWeight: 600, flexShrink: 0 }}>
                                                        Contact Name:
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ flex: 1, minWidth: 0, wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
                                                        {rows?.orderRecipient?.contactName ? rows?.orderRecipient?.contactName : '-'}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
                                                    <Typography variant="body2" sx={{ width: '160px', minWidth: '160px', fontWeight: 600, flexShrink: 0 }}>
                                                        Email:
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ flex: 1, minWidth: 0, wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
                                                        {rows?.orderRecipient?.emailId || rows?.orderRecipient?.email || '-'}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                                    <Typography variant="body2" sx={{ width: '160px', minWidth: '160px', fontWeight: 600, flexShrink: 0 }}>
                                                        Contact:
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ flex: 1, minWidth: 0, wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
                                                        {rows?.orderRecipient?.contactNo || '-'}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Box>
                                        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: 'text.primary' }}>
                                            Schedule Information
                                        </Typography>
                                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                            <CalendarTodayIcon sx={{ fontSize: 18, mr: 1, mt: 0.2, color: 'text.secondary' }} />
                                            <Box sx={{ width: '100%' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
                                                    <Typography variant="body2" sx={{ width: '120px', fontWeight: 600, flexShrink: 0 }}>
                                                        Expected Date:
                                                    </Typography>
                                                    {(labUserCheck?.UserType !== 'External' && rows?.status === 1) ? (
                                                        <DateInputField
                                                            value={localRows?.orderRecipient?.date || ''}
                                                            onChange={(iso) => setLocalRows((prev: any) => ({ ...prev, orderRecipient: { ...prev?.orderRecipient, date: iso } }))}
                                                            required
                                                            error={isExpectedDateMissing || isExpectedDateInPast}
                                                            helperText={isExpectedDateMissing ? 'Expected Date is required' : isExpectedDateInPast ? 'Past dates are not allowed' : ''}
                                                            min={minExpectedDate}
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    ) : (
                                                        <Typography variant="body2">
                                                            {(localRows?.orderRecipient?.date || rows?.orderRecipient?.date)
                                                                ? moment(localRows?.orderRecipient?.date || rows?.orderRecipient?.date).format('DD/MM/YYYY')
                                                                : '-'}
                                                        </Typography>
                                                    )}
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Grid>
                                {!(rows?.needsDelivery) && <Grid item xs={12} className="delivery-address-section">
                                    <Divider sx={{ my: 1 }} />
                                    <Box sx={{ display: 'flex', alignItems: 'flex-start', mt: 3 }}>
                                        <LocationOnIcon sx={{ fontSize: 18, mr: 1, mt: 0.2, color: 'text.secondary' }} />
                                        <Typography variant="body2" sx={{ width: '160px', minWidth: '160px', fontWeight: 600, flexShrink: 0 }}>
                                            Pickup Location:
                                        </Typography>
                                        <Typography variant="body2" sx={{ flex: 1, minWidth: 0, wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
                                            {rows?.orderRecipient?.pickUpLocation || '-'}
                                        </Typography>
                                    </Box>
                                </Grid>}
                                <Grid item xs={12} className="delivery-address-section">
                                    <Divider sx={{ my: 1 }} />
                                    <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: 'text.primary' }}>
                                        {rows?.needsDelivery ? 'Delivery Address' : 'Pickup Address'}
                                    </Typography>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
                                                <LocationOnIcon sx={{ fontSize: 18, mr: 1, mt: 0.2, color: 'text.secondary' }} />
                                                <Box sx={{ width: '100%' }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
                                                        <Typography variant="body2" sx={{ width: '160px', minWidth: '160px', fontWeight: 600, flexShrink: 0 }}>
                                                            Suburb:
                                                        </Typography>
                                                        <Typography variant="body2" sx={{ flex: 1, minWidth: 0, wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
                                                            {rows?.orderRecipient?.suburb || '-'}
                                                        </Typography>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
                                                        <Typography variant="body2" sx={{ width: '160px', minWidth: '160px', fontWeight: 600, flexShrink: 0 }}>
                                                            Street:
                                                        </Typography>
                                                        <Typography variant="body2" sx={{ flex: 1, minWidth: 0, wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
                                                            {rows?.orderRecipient?.street || '-'}
                                                        </Typography>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
                                                        <Typography variant="body2" sx={{ width: '160px', minWidth: '160px', fontWeight: 600, flexShrink: 0 }}>
                                                            State:
                                                        </Typography>
                                                        <Typography variant="body2" sx={{ flex: 1, minWidth: 0, wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
                                                            {rows?.orderRecipient?.state || '-'}
                                                        </Typography>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
                                                        <Typography variant="body2" sx={{ width: '160px', minWidth: '160px', fontWeight: 600, flexShrink: 0 }}>
                                                            Country:
                                                        </Typography>
                                                        <Typography variant="body2" sx={{ flex: 1, minWidth: 0, wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
                                                            {rows?.orderRecipient?.country || '-'}
                                                        </Typography>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
                                                        <Typography variant="body2" sx={{ width: '160px', minWidth: '160px', fontWeight: 600, flexShrink: 0 }}>
                                                            Postal Code:
                                                        </Typography>
                                                        <Typography variant="body2" sx={{ flex: 1, minWidth: 0, wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
                                                            {rows?.orderRecipient?.postalCode || '-'}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} className="recipient-instructions" sx={{ width: '100%' }}>
                                            <Box
                                                className="recipient-instruction-row"
                                                sx={{ display: 'flex', alignItems: 'flex-start', width: '100%', gap: 1, mb: 1 }}
                                            >
                                                <Typography
                                                    variant="body2"
                                                    className="recipient-instruction-label"
                                                    sx={{ width: '160px', minWidth: '160px', fontWeight: 600, flexShrink: 0, whiteSpace: 'nowrap' }}
                                                >
                                                    Special Instructions:
                                                </Typography>
                                                <Typography
                                                    variant="body2"
                                                    className="recipient-instruction-value"
                                                    sx={{ flex: '0 1 auto', maxWidth: { xs: '100%', sm: '60%' }, minWidth: 0, whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'anywhere' }}
                                                >
                                                    {rows?.orderRecipient?.specialInstruction || rows?.orderRecipient?.specialInstructions || rows?.orderRecipient?.instructions || '-'}
                                                </Typography>
                                            </Box>
                                            <Box
                                                className="recipient-instruction-row"
                                                sx={{ display: 'flex', alignItems: 'flex-start', width: '100%', gap: 1 }}
                                            >
                                                <Typography
                                                    variant="body2"
                                                    className="recipient-instruction-label"
                                                    sx={{ width: '160px', minWidth: '160px', fontWeight: 600, flexShrink: 0, whiteSpace: 'nowrap' }}
                                                >
                                                    Delivery Instructions:
                                                </Typography>
                                                <Typography
                                                    variant="body2"
                                                    className="recipient-instruction-value"
                                                    sx={{ flex: '0 1 auto', maxWidth: { xs: '100%', sm: '60%' }, minWidth: 0, whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'anywhere' }}
                                                >
                                                    {rows?.orderRecipient?.deliveryInstruction || rows?.orderRecipient?.deliveryInstructions || '-'}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {/* Dispatch Details Section Logic */}
                                {(rows?.status === 1 || rows?.status === 2 || rows?.status === 3 || rows?.status === 4) && (
                                    <Grid item xs={12}>
                                        <Box
                                            component="hr"
                                            className="print-top-separator"
                                            sx={{
                                                border: 0,
                                                height: 0,
                                                borderTop: '1px solid rgba(0, 0, 0, 0.12)',
                                                my: 1,
                                            }}
                                        />
                                        <Grid container spacing={2} className="despatch-details-grid">
                                            {(rows?.status === 1 && userType === 'Internal') && (
                                                <Grid item xs={12} md={4} className="despatch-print-field">
                                                    <Box className="print-hide" mt={1}>
                                                        <TextField
                                                            select
                                                            fullWidth
                                                            size="small"
                                                            label="Dispatch Office"
                                                            value={localRows.despatchLocationID || ''}
                                                            onChange={(e) => setLocalRows((prev: any) => ({ ...prev, despatchLocationID: e.target.value }))}
                                                            required
                                                            error={rows?.status === 1 && !localRows.despatchLocationID}
                                                            helperText={rows?.status === 1 && !localRows.despatchLocationID ? 'Dispatch Office is required' : ''}
                                                            disabled={(() => {
                                                                const hasAdd = labUserCheck?.Permission?.includes('AddContainerOrder');
                                                                const hasEdit = labUserCheck?.Permission?.includes('EditContainerOrder');
                                                                if (hasAdd && !hasEdit) return false;
                                                                if (!hasAdd && hasEdit) return true;
                                                                if (hasAdd && hasEdit) return false;
                                                                return true;
                                                            })()}
                                                        >
                                                            {dispatchOffices.map((office) => (
                                                                <MenuItem key={office.id || office} value={office.id || office}>
                                                                    {office.name || office}
                                                                </MenuItem>
                                                            ))}
                                                        </TextField>
                                                    </Box>
                                                    <Box
                                                        className="print-status-text"
                                                        sx={{ display: 'none', '@media print': { display: 'block !important' } }}
                                                    >
                                                        <Typography variant="subtitle2" sx={{ color: 'text.primary', mt: 1, textAlign: 'left !important' }}>
                                                            <strong>Dispatch Office:</strong> {getDispatchOfficeLabel(localRows.despatchLocationID || rows?.despatchLocationID || rows?.despatchLocation)}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            )}

                                            {/* Status 2: Date Packed mandatory, Items non-mandatory */}
                                            {rows?.status === 2 && (
                                                <>
                                                    <Grid item xs={12} sm={6} md={4} className="despatch-print-field">
                                                        <Typography variant="subtitle2" sx={{ color: 'text.primary', mt: 1, textAlign: 'left !important' }}>
                                                            <strong>Dispatch Office:</strong> {rows?.despatchLocation || '-'}
                                                        </Typography>
                                                    </Grid>
                                                    {userType === 'Internal' && (
                                                        <>
                                                            <Grid item xs={12} sm={6} md={4} className="despatch-print-field">
                                                                <Box className="print-hide">
                                                                    <TextField
                                                                        fullWidth
                                                                        label="Items Packed"
                                                                        value={localRows.itemsPacked || ''}
                                                                        onChange={(e: any) => setLocalRows((prev: any) => ({ ...prev, itemsPacked: e.target.value }))}
                                                                        size="small"
                                                                    />
                                                                </Box>
                                                                <Box
                                                                    className="print-status-text"
                                                                    sx={{ display: 'none', '@media print': { display: 'block !important' } }}
                                                                >
                                                                    <Typography variant="subtitle2" sx={{ color: 'text.primary', mt: 1, textAlign: 'left !important' }}>
                                                                        <strong>Items Packed:</strong> {localRows.itemsPacked || rows?.itemsPacked || '-'}
                                                                    </Typography>
                                                                </Box>
                                                            </Grid>
                                                        </>
                                                    )}
                                                </>
                                            )}
                                            {/* Status 3: Awaiting Dispatch - Delivery or Pickup */}
                                            {rows?.status === 3 && (
                                                <>
                                                    {rows?.needsDelivery ? (
                                                        <>
                                                            <Grid item xs={12} sm={6} md={4} className="despatch-print-field">
                                                                <Typography variant="body2" sx={{ color: 'text.primary', mt: 1 }}>
                                                                    <strong>Dispatch Office:</strong> {rows?.despatchLocation || '-'}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={4} className="despatch-print-field">
                                                                <Typography variant="body2" sx={{ color: 'text.primary', mt: 1 }}>
                                                                    <strong>Date Packed:</strong> {rows?.datePacked ? moment(rows.datePacked).format('DD/MM/YYYY') : '-'}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={4} className="despatch-print-field">
                                                                <Typography variant="body2" sx={{ color: 'text.primary', mt: 1 }}>
                                                                    <strong>Items Packed:</strong> {rows?.itemsPacked || '-'}
                                                                </Typography>
                                                            </Grid>
                                                            {userType === 'Internal' && (
                                                                <>
                                                                    <Grid item xs={12} sm={6} md={4} className="despatch-print-field print-hide-price">
                                                                        <Box className="print-hide">
                                                                            <TextField
                                                                                fullWidth
                                                                                size="small"
                                                                                label="Courier Info"
                                                                                value={localRows.courierInfo || ''}
                                                                                onChange={(e) => setLocalRows((prev: any) => ({ ...prev, courierInfo: e.target.value }))}
                                                                                required
                                                                                error={!localRows.courierInfo}
                                                                                helperText={!localRows.courierInfo ? 'Courier Info is required' : ''}
                                                                            />
                                                                        </Box>
                                                                        <Box
                                                                            className="print-status-text"
                                                                            sx={{ display: 'none', '@media print': { display: 'block !important' } }}
                                                                        >
                                                                            <Typography variant="subtitle2" sx={{ color: 'text.primary', mt: 1, textAlign: 'left !important', fontWeight: 600 }}>
                                                                                Courier Info: {localRows.courierInfo || rows?.courierInfo || '-'}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={6} md={4} className="despatch-print-field print-hide-price">
                                                                        <Box className="print-hide">
                                                                            <TextField
                                                                                fullWidth
                                                                                label="Tracking Number"
                                                                                value={localRows.trackingID || ''}
                                                                                onChange={(e: any) => setLocalRows((prev: any) => ({ ...prev, trackingID: e.target.value }))}
                                                                                size="small"
                                                                                required
                                                                                error={!localRows.trackingID}
                                                                                helperText={!localRows.trackingID ? 'Tracking Number is required' : ''}
                                                                            />
                                                                        </Box>
                                                                        <Box
                                                                            className="print-status-text"
                                                                            sx={{ display: 'none', '@media print': { display: 'block !important' } }}
                                                                        >
                                                                            <Typography variant="subtitle2" sx={{ color: 'text.primary', mt: 1, textAlign: 'left !important', fontWeight: 600 }}>
                                                                                Tracking Number: {localRows.trackingID || rows?.trackingID || '-'}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={6} md={4} className="despatch-print-field">
                                                                        <Box className="print-hide">
                                                                            <TextField
                                                                                fullWidth
                                                                                label="Price (Incl. GST)"
                                                                                type="number"
                                                                                size="small"
                                                                                inputProps={{ step: '0.01', min: '0' }}
                                                                                value={localRows.price || ''}
                                                                                onChange={(e: any) => setLocalRows((prev: any) => ({ ...prev, price: e.target.value }))}
                                                                            />
                                                                        </Box>
                                                                    </Grid>
                                                                </>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Grid item xs={12} sm={6} md={4} className="despatch-print-field">
                                                                <Typography variant="body2" sx={{ color: 'text.primary', mt: 1 }}>
                                                                    <strong>Dispatch Office:</strong> {rows?.despatchLocation || '-'}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={4} className="despatch-print-field">
                                                                <Typography variant="body2" sx={{ color: 'text.primary', mt: 1 }}>
                                                                    <strong>Date Packed:</strong> {rows?.datePacked ? moment(rows.datePacked).format('DD/MM/YYYY') : '-'}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={4} className="despatch-print-field">
                                                                <Typography variant="body2" sx={{ color: 'text.primary', mt: 1 }}>
                                                                    <strong>Items Packed:</strong> {rows?.itemsPacked || '-'}
                                                                </Typography>
                                                            </Grid>
                                                            {userType === 'Internal' && (
                                                                <>
                                                                    <Grid item xs={12} sm={6} md={4} className="despatch-print-field">
                                                                        <Box className="print-hide">
                                                                            <TextField
                                                                                type="date"
                                                                                fullWidth
                                                                                size="small"
                                                                                label="PickedUp On"
                                                                                value={
                                                                                    localRows.pickedUpOn
                                                                                        ? moment(localRows.pickedUpOn).format('YYYY-MM-DD')
                                                                                        : ''
                                                                                }
                                                                                onChange={(e) => setLocalRows((prev: any) => ({ ...prev, pickedUpOn: e.target.value }))}
                                                                                required
                                                                                error={!localRows.pickedUpOn}
                                                                                helperText={!localRows.pickedUpOn ? 'PickedUp On date is required' : ''}
                                                                                InputLabelProps={{ shrink: true }}
                                                                            />
                                                                        </Box>
                                                                        <Box
                                                                            className="print-status-text"
                                                                            sx={{ display: 'none', '@media print': { display: 'block !important' } }}
                                                                        >
                                                                            <Typography variant="subtitle2" sx={{ color: 'text.primary', mt: 1, textAlign: 'left !important', fontWeight: 600 }}>
                                                                                PickedUp On: {localRows.pickedUpOn ? moment(localRows.pickedUpOn).format('MM/DD/YYYY') : rows?.pickedUpOn ? moment(rows.pickedUpOn).format('MM/DD/YYYY') : '-'}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Grid>
                                                                    {localRows.needsDelivery ? (
                                                                        <Grid item xs={12} sm={6} md={4} className="despatch-print-field">
                                                                            <Box className="print-hide">
                                                                                <TextField
                                                                                    fullWidth
                                                                                    label="Price (Incl. GST)"
                                                                                    type="number"
                                                                                    size="small"
                                                                                    value={localRows.price || ''}
                                                                                    onChange={(e: any) => setLocalRows((prev: any) => ({ ...prev, price: e.target.value }))}
                                                                                    inputProps={{ step: '0.01', min: '0' }}
                                                                                />
                                                                            </Box>
                                                                        </Grid>
                                                                    ) : null}
                                                                </>)}
                                                        </>
                                                    )}
                                                </>
                                            )}
                                            {/* Status 3: Awaiting Dispatch - Delivery or Pickup */}
                                            {rows?.status === 4 && (
                                                <>
                                                    {rows?.needsDelivery ? (
                                                        <>
                                                            <Grid item xs={12} sm={6} md={4} className="despatch-print-field">
                                                                <Typography variant="body2" sx={{ color: 'text.primary', mt: 1 }}>
                                                                    <strong>Dispatch Office:</strong> {rows?.despatchLocation || '-'}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={4} className="despatch-print-field">
                                                                <Typography variant="body2" sx={{ color: 'text.primary', mt: 1 }}>
                                                                    <strong>Date Packed:</strong> {rows?.datePacked ? moment(rows.datePacked).format('DD/MM/YYYY') : '-'}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={4} className="despatch-print-field">
                                                                <Typography variant="body2" sx={{ color: 'text.primary', mt: 1 }}>
                                                                    <strong>Items Packed:</strong> {rows?.itemsPacked || '-'}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={4} className="despatch-print-field">
                                                                <Typography variant="body2" sx={{ color: 'text.primary', mt: 1 }}>
                                                                    <strong>Courier Info:</strong> {rows?.courierInfo || '-'}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={4} className="despatch-print-field">
                                                                <Typography variant="body2" sx={{ color: 'text.primary', mt: 1 }}>
                                                                    <strong>Tracking Number:</strong> {rows?.trackingID || '-'}
                                                                </Typography>
                                                            </Grid>
                                                            {userType === 'Internal' && (<Grid item xs={12} sm={6} md={4} className="despatch-print-field print-hide-price" sx={{ '@media print': { display: 'none !important' } }}>
                                                                <Typography variant="body2" sx={{ color: 'text.primary', mt: 1 }}>
                                                                    <strong>Price (Incl. GST):</strong> {rows?.price || '-'}
                                                                </Typography>
                                                            </Grid>)}
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Grid item xs={12} sm={6} md={4} className="despatch-print-field">
                                                                <Typography variant="body2" sx={{ color: 'text.primary', mt: 1 }}>
                                                                    <strong>Dispatch Office:</strong> {rows?.despatchLocation || '-'}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={4} className="despatch-print-field">
                                                                <Typography variant="body2" sx={{ color: 'text.primary', mt: 1 }}>
                                                                    <strong>Date Packed:</strong> {rows?.datePacked ? moment(rows.datePacked).format('DD/MM/YYYY') : '-'}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={4} className="despatch-print-field">
                                                                <Typography variant="body2" sx={{ color: 'text.primary', mt: 1 }}>
                                                                    <strong>Items Packed:</strong> {rows?.itemsPacked || '-'}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={4} className="despatch-print-field">
                                                                <Typography variant="body2" sx={{ color: 'text.primary', mt: 1 }}>
                                                                    <strong>Pickedup On:</strong> {rows?.pickedUpOn ? moment(rows.pickedUpOn).format('DD/MM/YYYY') : '-'}
                                                                </Typography>
                                                            </Grid>
                                                            {userType === 'Internal' && (<Grid item xs={12} sm={6} md={4} className="despatch-print-field print-hide-price" sx={{ '@media print': { display: 'none !important' } }}>
                                                                <Typography variant="body2" sx={{ color: 'text.primary', mt: 1 }}>
                                                                    <strong>Price (Incl. GST):</strong> {rows?.price || '-'}
                                                                </Typography>
                                                            </Grid>)}
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </Grid>
                                    </Grid>
                                )}
                            </Grid>
                        </CardContent>
                        </Card>

                        {/* Containers Table */}
                        <Box sx={{ mb: 4 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, mb: 2 }}>
                                <Typography variant="h6"
                                    sx={{
                                        fontWeight: 600,
                                        '@media print': {
                                            color: '#000 !important',
                                        },
                                    }}
                                >
                                    Containers
                                </Typography>
                                {rows?.hasAttachments && rows?.id && (
                                    <Box className="no-print" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                                        <Typography
                                            component="button"
                                            type="button"
                                            onClick={handleDownloadAttachments}
                                            sx={{
                                                background: 'transparent',
                                                border: 0,
                                                padding: 0,
                                                cursor: 'pointer',
                                                fontSize: '12px',
                                                color: '#003883',
                                                textDecoration: 'underline',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Download Attachments
                                        </Typography>
                                        {downloadAttachmentsError && (
                                            <Typography variant="caption" sx={{ color: '#d32f2f', mt: 0.5, maxWidth: 280, textAlign: 'right' }}>
                                                {downloadAttachmentsError}
                                            </Typography>
                                        )}
                                    </Box>
                                )}
                                {rows?.id && (
                                    <Button
                                        variant="contained"
                                        startIcon={<AddCircleOutlineOutlinedIcon />}
                                        onClick={() => handleAddContainersOpen('container')}
                                        disabled={!canEditRequestedOrder}
                                    >
                                        Add Container
                                    </Button>
                                )}
                            </Box>

                            <AddContainer
                                openAddContainers={openAddContainers}
                                addContainerType={addContainerType}
                                handleAddContainersClose={handleAddContainersClose}
                                handleAddContainer={handleAddContainer}
                                loadContainers={loadContainers}
                                parentData={{ ...localRows, bottleGroups: bottleGroupRows }}
                                isSaving={isAddingItem}
                            />

                            <Card variant="outlined" className="print-table-card" sx={{ borderRadius: 1 }}>
                                <CardContent sx={{ padding: '0px 0px !important' }}>
                                    <div className="print-area">
                                        <Table sx={{ minWidth: 600 }}>
                                            <TableHead sx={{ backgroundColor: 'rgb(0, 56, 131)' }}>
                                                <TableRow>
                                                    {columns.map(col => {
                                                        const allSelected = containerRows.length > 0 && containerRows.every(r => r.isCompleted);
                                                        const someSelected = containerRows.some(r => r.isCompleted) && !allSelected;
                                                        return (
                                                            <TableCell key={col.field} sx={{ color: '#fff', minWidth: col.minWidth, fontWeight: 600, padding: '12px' }}>
                                                                {col.isSelectAll ? (
                                                                    <>
                                                                        <Box className="print-hide">
                                                                            <Checkbox
                                                                                checked={allSelected}
                                                                                indeterminate={someSelected}
                                                                                onChange={(e) => {
                                                                                    if (e.target.checked) {
                                                                                        containerRows.forEach((_, idx) => handleTickToggle(idx, false, true));
                                                                                    } else {
                                                                                        containerRows.forEach((r, idx) => {
                                                                                            if (r.isCompleted) handleTickToggle(idx, false, true);
                                                                                        });
                                                                                    }
                                                                                }}
                                                                                sx={{
                                                                                    padding: 0,
                                                                                    color: '#fff',
                                                                                    '&.Mui-checked': { color: '#fff' },
                                                                                    '&.MuiCheckbox-indeterminate': { color: '#fff' }
                                                                                }}
                                                                                disabled={rows?.status === 1 || rows?.status === 3 || rows?.status === 4}
                                                                            />
                                                                        </Box>
                                                                        <Box className="print-status-text" sx={{ display: 'none', '@media print': { display: 'block !important' } }}>
                                                                            <Typography variant="body2">&nbsp;</Typography>
                                                                        </Box>
                                                                    </>
                                                                ) : (
                                                                    col.field === 'containerName' ? 'Container Name' : col.headerName
                                                                )}
                                                            </TableCell>
                                                        );
                                                    })}
                                                    <TableCell className="print-hide" align="center" sx={{ color: '#fff', fontWeight: 600, width: 48 }}>
                                                        Actions
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {containerRows.length === 0 ? (
                                                    <TableRow>
                                                        <TableCell colSpan={columns.length + 1} align="center" sx={{ py: 4 }}>
                                                            <Typography variant="body1" color="text.secondary">
                                                                No data available
                                                            </Typography>
                                                        </TableCell>
                                                    </TableRow>
                                                ) : (
                                                    containerRows.map((r, idx) => (
                                                        <TableRow key={idx}
                                                            sx={{
                                                                backgroundColor: r.isCompleted ? '#f8f9fa' : 'inherit',
                                                                '& .MuiTableCell-root': {
                                                                    backgroundColor: r.isCompleted ? '#f8f9fa' : 'inherit',
                                                                    fontWeight: r.isCompleted ? 600 : 'normal'
                                                                }
                                                            }}
                                                        >
                                                            {columns.map(col => {
                                                                if (col.field === 'select' && col.isCheckbox) {
                                                                    return (
                                                                        <TableCell key={col.field} sx={{ padding: '8px' }}>
                                                                            <Box className="print-hide">
                                                                                <Tooltip title={r.isCompleted ? 'Mark as incomplete' : 'Mark as completed'} arrow>
                                                                                    <IconButton
                                                                                        onClick={() => handleTickToggle(idx, true, true)}
                                                                                        disabled={rows?.status === 1 || rows?.status === 3 || rows?.status === 4}
                                                                                        size="small"
                                                                                        sx={{
                                                                                            color: r.isCompleted ? '#2e7d32' : '#9e9e9e',
                                                                                            '&:hover': {
                                                                                                backgroundColor: r.isCompleted ? '#e8f5e8' : '#f5f5f5'
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        {r.isCompleted ? <CheckCircleIcon /> : <CheckCircleOutlineIcon />}
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                            </Box>
                                                                            <Box
                                                                                className="print-status-text"
                                                                                sx={{
                                                                                    display: 'none',
                                                                                    '@media print': { display: 'block !important' }
                                                                                }}
                                                                            >
                                                                                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                                                                    {r.isCompleted ? 'Completed' : 'Pending'}
                                                                                </Typography>
                                                                            </Box>
                                                                        </TableCell>
                                                                    );
                                                                }

                                                                if (col.field === 'orderedOn') {
                                                                    const dateValue = r[col.field];
                                                                    let formattedDate = '-';
                                                                    if (dateValue) {
                                                                        const d = new Date(dateValue);
                                                                        formattedDate = `${d.getDate().toString().padStart(2, '0')}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getFullYear()}`;
                                                                    }
                                                                    return (
                                                                        <TableCell key={col.field} sx={{ padding: '8px' }}>
                                                                            {formattedDate}
                                                                        </TableCell>
                                                                    );
                                                                }

                                                                if (col.field === 'containerName') {
                                                                    return (
                                                                        <TableCell
                                                                            key={col.field}
                                                                            sx={{
                                                                                padding: '16px',
                                                                                whiteSpace: 'normal',
                                                                                wordBreak: 'break-word',
                                                                                overflowWrap: 'anywhere'
                                                                            }}
                                                                        >
                                                                            <Typography
                                                                                variant="body2"
                                                                                sx={{
                                                                                    whiteSpace: 'normal',
                                                                                    wordBreak: 'break-word',
                                                                                    overflowWrap: 'anywhere',
                                                                                    fontWeight: 600
                                                                                }}
                                                                            >
                                                                                {getItemDisplayName(r)}
                                                                            </Typography>
                                                                        </TableCell>
                                                                    );
                                                                }

                                                                if (col.field === 'status') {
                                                                    let statusText = '-';
                                                                    if (r.status === 1) statusText = 'Requested';
                                                                    else if (r.status === 2) statusText = 'Inprogress';
                                                                    else if (r.status === 3) statusText = 'Completed';
                                                                    return (
                                                                        <TableCell key={col.field} sx={{ padding: '8px' }}>
                                                                            {statusText}
                                                                        </TableCell>
                                                                    );
                                                                }

                                                                if (col.isEnable) {
                                                                    if (col.field === 'fulfilledQuantity' && col.validation) {
                                                                        let fulfilledValue = r?.status === 2 && r.fulfilledQuantity === null ? "" : r?.fulfilledQuantity;
                                                                        return (
                                                                            <TableCell key={col.field} sx={{ padding: '8px' }}>
                                                                                <Box className="print-hide">
                                                                                    <TextField
                                                                                        size="small"
                                                                                        variant="outlined"
                                                                                        fullWidth
                                                                                        value={fulfilledValue}
                                                                                        onChange={userType === 'Internal' && !r.isCompleted && rows?.status === 2 ? e => { const value = e.target.value; if (value === '' || /^\d*$/.test(value)) { handleCellChange(idx, col.field, value, true); } } : undefined}
                                                                                        onBlur={userType === 'Internal' && !r.isCompleted && rows?.status === 2 ? e => { const value = e.target.value; if (value === '' || isNaN(Number(value)) || Number(value) < 0) { handleCellChange(idx, col.field, 0, true); } } : undefined}
                                                                                        type="text"
                                                                                        inputProps={{ style: { width: 60 } }}
                                                                                        InputProps={{ readOnly: userType !== 'Internal' || r.isCompleted || rows?.status !== 2 || r.fulfilledDisabled }}
                                                                                        disabled={rows?.status === 1 || rows?.status === 3 || rows?.status === 4 || r.fulfilledDisabled}
                                                                                    />
                                                                                </Box>
                                                                                <Box className="print-status-text" sx={{ display: 'none', '@media print': { display: 'block !important' } }}>
                                                                                    <Typography variant="body2">
                                                                                        {fulfilledValue !== '' && fulfilledValue !== null && fulfilledValue !== undefined ? fulfilledValue : '-'}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </TableCell>
                                                                        );
                                                                    }
                                                                    if (col.field === 'comments') {
                                                                        const fulfilledValue = r.fulfilledQuantity ?? '';
                                                                        const commentsRequired =
                                                                            rows?.status === 2 &&
                                                                            fulfilledValue !== '' &&
                                                                            Number(fulfilledValue) !== Number(r.requestedQuantity);

                                                                        return (
                                                                            <TableCell key={col.field} sx={{ padding: '8px' }}>
                                                                                <Box className="print-hide">
                                                                                    <TextField
                                                                                        size="small"
                                                                                        variant="outlined"
                                                                                        fullWidth
                                                                                        select
                                                                                        label="Comments"
                                                                                        value={r.comments ?? ''}
                                                                                        sx={{ maxWidth: { xs: '100px', sm: '116px', md: '100%' } }}
                                                                                        onChange={
                                                                                            userType === 'Internal' && !r.isCompleted
                                                                                                ? (e) => {
                                                                                                    const value = e.target.value;

                                                                                                    // Update comment
                                                                                                    handleCellChange(idx, col.field, value, true);

                                                                                                    // Trigger tick only when a valid comment is selected
                                                                                                    if (
                                                                                                        commentsRequired &&
                                                                                                        value &&
                                                                                                        value.trim() !== ''
                                                                                                    ) {
                                                                                                        handleTickToggle(idx, false, true);
                                                                                                    }
                                                                                                }
                                                                                                : undefined
                                                                                        }
                                                                                        InputProps={{
                                                                                            readOnly: userType !== 'Internal' || r.isCompleted,
                                                                                        }}
                                                                                        disabled={
                                                                                            rows?.status !== 2 ||
                                                                                            r.isCompleted ||
                                                                                            !commentsRequired
                                                                                        }
                                                                                        required={commentsRequired}
                                                                                        error={r.showCommentsError}
                                                                                        helperText={
                                                                                            r.showCommentsError ? 'Comments is required' : ''
                                                                                        }
                                                                                    >
                                                                                        <MenuItem value="">
                                                                                            Select comment
                                                                                        </MenuItem>
                                                                                        {commentOptions.map((option) => (
                                                                                            <MenuItem key={option} value={option}>
                                                                                                {option}
                                                                                            </MenuItem>
                                                                                        ))}
                                                                                    </TextField>
                                                                                </Box>

                                                                                <Box
                                                                                    className="print-status-text"
                                                                                    sx={{
                                                                                        display: 'none',
                                                                                        '@media print': {
                                                                                            display: 'block !important',
                                                                                        },
                                                                                    }}
                                                                                >
                                                                                    <Typography variant="body2">
                                                                                        {r.comments ?? '-'}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </TableCell>
                                                                        );
                                                                    }
                                                                    return (
                                                                        <TableCell key={col.field} sx={{ padding: '8px' }}>
                                                                            <TextField
                                                                                size="small"
                                                                                variant="outlined"
                                                                                fullWidth
                                                                                value={r[col.field] ?? ''}
                                                                                onChange={userType === 'Internal' && !r.isCompleted ? e => handleCellChange(idx, col.field, e.target.value, true) : undefined}
                                                                                InputProps={{ readOnly: userType !== 'Internal' || r.isCompleted }}
                                                                                disabled={rows?.status === 3}
                                                                            />
                                                                        </TableCell>
                                                                    );
                                                                }
                                                                // ========================================================
                                                                // REQUESTED QUANTITY
                                                                // ========================================================
                                                                if (col.field === 'requestedQuantity') {
                                                                    const requestedValue =
                                                                        r.requestedQuantity ?? '';

                                                                    const requestedDisabled =
                                                                        !canEditRequestedQuantity(r);

                                                                    return (
                                                                        <TableCell
                                                                            key={col.field}
                                                                            sx={{ padding: '8px' }}
                                                                        >
                                                                            <Box className="print-hide">
                                                                                <TextField
                                                                                    size="small"
                                                                                    variant="outlined"
                                                                                    fullWidth
                                                                                    value={requestedValue}
                                                                                    type="text"
                                                                                    onChange={
                                                                                        !requestedDisabled
                                                                                            ? (e) => {
                                                                                                const value =
                                                                                                    e.target.value;

                                                                                                if (
                                                                                                    value === '' ||
                                                                                                    /^\d*$/.test(value)
                                                                                                ) {
                                                                                                    handleCellChange(
                                                                                                        idx,
                                                                                                        col.field,
                                                                                                        value,
                                                                                                        true
                                                                                                    );
                                                                                                }
                                                                                            }
                                                                                            : undefined
                                                                                    }
                                                                                    onBlur={
                                                                                        !requestedDisabled
                                                                                            ? (e) => {
                                                                                                const value =
                                                                                                    e.target.value;

                                                                                                if (
                                                                                                    value === '' ||
                                                                                                    isNaN(
                                                                                                        Number(value)
                                                                                                    ) ||
                                                                                                    Number(value) < 0
                                                                                                ) {
                                                                                                    handleCellChange(
                                                                                                        idx,
                                                                                                        col.field,
                                                                                                        0,
                                                                                                        true
                                                                                                    );
                                                                                                }
                                                                                            }
                                                                                            : undefined
                                                                                    }
                                                                                    inputProps={{
                                                                                        style: {
                                                                                            width: 60,
                                                                                            textAlign: 'center'
                                                                                        }
                                                                                    }}
                                                                                    InputProps={{
                                                                                        readOnly: requestedDisabled
                                                                                    }}
                                                                                    disabled={requestedDisabled}
                                                                                />
                                                                            </Box>

                                                                            <Box
                                                                                className="print-status-text"
                                                                                sx={{
                                                                                    display: 'none',
                                                                                    '@media print': {
                                                                                        display:
                                                                                            'block !important'
                                                                                    }
                                                                                }}
                                                                            >
                                                                                <Typography variant="body2">
                                                                                    {requestedValue !== ''
                                                                                        ? requestedValue
                                                                                        : '-'}
                                                                                </Typography>
                                                                            </Box>
                                                                        </TableCell>
                                                                    );
                                                                }

                                                                // ========================================================
                                                                // MULTIPLIER
                                                                // ========================================================
                                                                if (col.field === 'multiplier') {
                                                                    const multiplierValue =
                                                                        Number(r.multiplier) || 1;

                                                                    const multiplierDisabled =
                                                                        !canEditRequestedQuantity(r);

                                                                    return (
                                                                        <TableCell
                                                                            key={col.field}
                                                                            sx={{ padding: '8px' }}
                                                                        >
                                                                            <Box className="print-hide">
                                                                                <Box
                                                                                    sx={{
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        border:
                                                                                            '1px solid rgba(0,0,0,0.23)',
                                                                                        borderRadius: 1,
                                                                                        overflow: 'hidden',
                                                                                        height: 32,
                                                                                        width: 'fit-content'
                                                                                    }}
                                                                                >
                                                                                    {/* Minus */}
                                                                                    <IconButton
                                                                                        size="small"
                                                                                        disabled={
                                                                                            multiplierDisabled ||
                                                                                            multiplierValue <= 1
                                                                                        }
                                                                                        onClick={() =>
                                                                                            handleCellChange(
                                                                                                idx,
                                                                                                col.field,
                                                                                                Math.max(
                                                                                                    1,
                                                                                                    multiplierValue - 1
                                                                                                ),
                                                                                                true
                                                                                            )
                                                                                        }
                                                                                        sx={{
                                                                                            borderRadius: 0,
                                                                                            height: '100%',
                                                                                            width: 24,
                                                                                            p: 0,
                                                                                            minWidth: 0
                                                                                        }}
                                                                                    >
                                                                                        <Remove
                                                                                            sx={{
                                                                                                fontSize: 14
                                                                                            }}
                                                                                        />
                                                                                    </IconButton>

                                                                                    {/* Multiplier Input */}
                                                                                    <input
                                                                                        type="number"
                                                                                        value={multiplierValue}
                                                                                        min={1}
                                                                                        max={6}
                                                                                        disabled={
                                                                                            multiplierDisabled
                                                                                        }
                                                                                        onChange={(e) => {
                                                                                            const val = parseInt(
                                                                                                e.target.value,
                                                                                                10
                                                                                            );

                                                                                            if (
                                                                                                !isNaN(val) &&
                                                                                                val >= 1 &&
                                                                                                val <= 6
                                                                                            ) {
                                                                                                handleCellChange(
                                                                                                    idx,
                                                                                                    col.field,
                                                                                                    val,
                                                                                                    true
                                                                                                );
                                                                                            }
                                                                                        }}
                                                                                        style={{
                                                                                            width: 35,
                                                                                            textAlign: 'center',
                                                                                            border: 'none',
                                                                                            borderLeft:
                                                                                                '1px solid rgba(0,0,0,0.12)',
                                                                                            borderRight:
                                                                                                '1px solid rgba(0,0,0,0.12)',
                                                                                            outline: 'none',
                                                                                            fontSize: '12px',
                                                                                            height: '100%',
                                                                                            padding: 0,
                                                                                            WebkitAppearance:
                                                                                                'none',
                                                                                            MozAppearance:
                                                                                                'textfield'
                                                                                        }}
                                                                                    />

                                                                                    {/* Plus */}
                                                                                    <IconButton
                                                                                        size="small"
                                                                                        disabled={
                                                                                            multiplierDisabled
                                                                                        }
                                                                                        onClick={() =>
                                                                                            handleCellChange(
                                                                                                idx,
                                                                                                col.field,
                                                                                                Math.min(6, multiplierValue + 1),
                                                                                                true
                                                                                            )
                                                                                        }
                                                                                        sx={{
                                                                                            borderRadius: 0,
                                                                                            height: '100%',
                                                                                            width: 24,
                                                                                            p: 0,
                                                                                            minWidth: 0
                                                                                        }}
                                                                                    >
                                                                                        <Add
                                                                                            sx={{
                                                                                                fontSize: 14
                                                                                            }}
                                                                                        />
                                                                                    </IconButton>
                                                                                </Box>
                                                                            </Box>

                                                                            {/* Print Value */}
                                                                            <Box
                                                                                className="print-status-text"
                                                                                sx={{
                                                                                    display: 'none',
                                                                                    '@media print': {
                                                                                        display:
                                                                                            'block !important'
                                                                                    }
                                                                                }}
                                                                            >
                                                                                <Typography variant="body2">
                                                                                    {multiplierValue}
                                                                                </Typography>
                                                                            </Box>
                                                                        </TableCell>
                                                                    );
                                                                }

                                                                // ========================================================
                                                                // UNITS
                                                                // ========================================================
                                                                if (col.field === 'units') {
                                                                    const unitsValue = r.units ?? '';

                                                                    const unitsDisabled =
                                                                        userType !== 'Internal' ||
                                                                        r.isCompleted ||
                                                                        rows?.status !== 2;

                                                                    return (
                                                                        <TableCell
                                                                            key={col.field}
                                                                            sx={{ padding: '8px' }}
                                                                        >
                                                                            <Box className="print-hide">
                                                                                <TextField
                                                                                    size="small"
                                                                                    variant="outlined"
                                                                                    fullWidth
                                                                                    value={unitsValue}
                                                                                    onChange={
                                                                                        !unitsDisabled
                                                                                            ? (e) =>
                                                                                                handleCellChange(
                                                                                                    idx,
                                                                                                    col.field,
                                                                                                    e.target.value,
                                                                                                    true
                                                                                                )
                                                                                            : undefined
                                                                                    }
                                                                                    InputProps={{
                                                                                        readOnly: unitsDisabled
                                                                                    }}
                                                                                    disabled={unitsDisabled}
                                                                                />
                                                                            </Box>

                                                                            <Box
                                                                                className="print-status-text"
                                                                                sx={{
                                                                                    display: 'none',
                                                                                    '@media print': {
                                                                                        display:
                                                                                            'block !important'
                                                                                    }
                                                                                }}
                                                                            >
                                                                                <Typography variant="body2">
                                                                                    {unitsValue !== ''
                                                                                        ? unitsValue
                                                                                        : '-'}
                                                                                </Typography>
                                                                            </Box>
                                                                        </TableCell>
                                                                    );
                                                                }
                                                                return (
                                                                    <TableCell key={col.field} sx={{ padding: '16px' }}>
                                                                        {r[col.field] !== undefined && r[col.field] !== null && r[col.field] !== '' ? r[col.field] : '-'}
                                                                    </TableCell>
                                                                );
                                                            })}
                                                            {renderItemDeleteAction(r, idx, true)}
                                                        </TableRow>
                                                    ))
                                                )}
                                            </TableBody>
                                        </Table>
                                    </div>
                                </CardContent>
                            </Card>
                        </Box >

                        <BottleGroupFromQuote
                            rows={rows}
                            bottleGroupRows={bottleGroupRows}
                            bottleGroupColumns={bottleGroupColumns}
                            expandedBottleGroups={expandedBottleGroups}
                            toggleBottleGroupExpanded={toggleBottleGroupExpanded}
                            resolveBottleGroupName={resolveBottleGroupName}
                            handleBottleGroupCellChange={handleBottleGroupCellChange}
                            handleBottleGroupTickToggle={handleBottleGroupTickToggle}
                            isRowEditable={isRowEditable}
                            canEditRequestedQuantity={canEditRequestedQuantity}
                            canAddContainers={canEditRequestedOrder}
                            commentOptions={commentOptions}
                            renderReadonlyTreeItems={renderReadonlyTreeItems}
                            handleAddContainersOpen={handleAddContainersOpen}
                            handlePlaceOrderForGroup={handlePlaceOrderForGroup}
                        />

                        {/* Quality & Packing Table */}
                        <Box sx={{ mb: 4 }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    mb: 2,
                                }}
                            >
                                {/* Left */}
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontWeight: 600,
                                        '@media print': {
                                            color: '#000 !important',
                                        },
                                    }}
                                >
                                    Quality & Packing
                                </Typography>

                                {/* Right */}
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 2,
                                    }}
                                >
                                    {labUserCheck?.UserType === 'Internal' && (
                                        <FormControlLabel
                                            label="Eskies to fit"
                                            control={
                                                <Checkbox
                                                    checked={!!rows?.eskiesToFit}
                                                    disabled
                                                    sx={{
                                                        '&.Mui-disabled': {
                                                            color: 'rgba(0, 0, 0, 0.26)',
                                                        },
                                                    }}
                                                />
                                            }
                                            sx={{
                                                m: 0,
                                                '&.Mui-disabled': {
                                                    opacity: 1,
                                                },
                                                '& .MuiFormControlLabel-label': {
                                                    color: 'rgba(0, 0, 0, 0.87)',
                                                },
                                                '& .MuiFormControlLabel-label.Mui-disabled': {
                                                    color: 'rgba(0, 0, 0, 0.87)',
                                                },
                                            }}
                                        />
                                    )}

                                    {rows?.id && (
                                        <Button
                                            variant="contained"
                                            startIcon={<AddCircleOutlineOutlinedIcon />}
                                            onClick={() => handleAddContainersOpen('quality')}
                                            disabled={!canEditRequestedOrder}
                                        >
                                            Add Package
                                        </Button>
                                    )}
                                </Box>
                            </Box>

                            <Card variant="outlined" className="print-table-card" sx={{ borderRadius: 1 }}>
                                <CardContent sx={{ padding: '0px 0px !important' }}>
                                    <div className="print-area">
                                        <Table sx={{ minWidth: 600 }}>
                                            <TableHead sx={{ backgroundColor: 'rgb(0, 56, 131)' }}>
                                                <TableRow>
                                                    {columns.map(col => {
                                                        const allSelected = packageRows.length > 0 && packageRows.every(r => r.isCompleted);
                                                        const someSelected = packageRows.some(r => r.isCompleted) && !allSelected;
                                                        return (
                                                            <TableCell key={col.field} sx={{ color: '#fff', minWidth: col.minWidth, fontWeight: 600, padding: '12px' }}>
                                                                {col.isSelectAll ? (
                                                                    <>
                                                                        <Box className="print-hide">
                                                                            <Checkbox
                                                                                checked={allSelected}
                                                                                indeterminate={someSelected}
                                                                                onChange={(e) => {
                                                                                    if (e.target.checked) {
                                                                                        packageRows.forEach((_, idx) => handleTickToggle(idx, false, false));
                                                                                    } else {
                                                                                        packageRows.forEach((r, idx) => {
                                                                                            if (r.isCompleted) handleTickToggle(idx, false, false);
                                                                                        });
                                                                                    }
                                                                                }}
                                                                                sx={{
                                                                                    padding: 0,
                                                                                    color: '#fff',
                                                                                    '&.Mui-checked': { color: '#fff' },
                                                                                    '&.MuiCheckbox-indeterminate': { color: '#fff' }
                                                                                }}
                                                                                disabled={rows?.status === 1 || rows?.status === 3 || rows?.status === 4}
                                                                            />
                                                                        </Box>
                                                                        <Box className="print-status-text" sx={{ display: 'none', '@media print': { display: 'block !important' } }}>
                                                                            <Typography variant="body2">&nbsp;</Typography>
                                                                        </Box>
                                                                    </>
                                                                ) : (
                                                                    col.field === 'containerName' ? 'Package Name' : col.headerName
                                                                )}
                                                            </TableCell>
                                                        );
                                                    })}
                                                    <TableCell className="print-hide" align="center" sx={{ color: '#fff', fontWeight: 600, width: 48 }}>
                                                        Actions
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {packageRows.length === 0 ? (
                                                    <TableRow>
                                                        <TableCell colSpan={columns.length + 1} align="center" sx={{ py: 4 }}>
                                                            <Typography variant="body1" color="text.secondary">
                                                                No data available
                                                            </Typography>
                                                        </TableCell>
                                                    </TableRow>
                                                ) : (
                                                    packageRows.map((r, idx) => (
                                                        <TableRow key={idx}
                                                            sx={{
                                                                backgroundColor: r.isCompleted ? '#f8f9fa' : 'inherit',
                                                                '& .MuiTableCell-root': {
                                                                    backgroundColor: r.isCompleted ? '#f8f9fa' : 'inherit',
                                                                    fontWeight: r.isCompleted ? 600 : 'normal'
                                                                }
                                                            }}
                                                        >
                                                            {columns.map(col => {
                                                                if (col.field === 'select' && col.isCheckbox) {
                                                                    return (
                                                                        <TableCell key={col.field} sx={{ padding: '8px' }}>
                                                                            <Box className="print-hide">
                                                                                <Tooltip title={r.isCompleted ? 'Mark as incomplete' : 'Mark as completed'} arrow>
                                                                                    <IconButton
                                                                                        onClick={() => handleTickToggle(idx, true, false)}
                                                                                        disabled={rows?.status === 1 || rows?.status === 3 || rows?.status === 4}
                                                                                        size="small"
                                                                                        sx={{
                                                                                            color: r.isCompleted ? '#2e7d32' : '#9e9e9e',
                                                                                            '&:hover': {
                                                                                                backgroundColor: r.isCompleted ? '#e8f5e8' : '#f5f5f5'
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        {r.isCompleted ? <CheckCircleIcon /> : <CheckCircleOutlineIcon />}
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                            </Box>
                                                                            <Box
                                                                                className="print-status-text"
                                                                                sx={{
                                                                                    display: 'none',
                                                                                    '@media print': { display: 'block !important' }
                                                                                }}
                                                                            >
                                                                                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                                                                    {r.isCompleted ? 'Completed' : 'Pending'}
                                                                                </Typography>
                                                                            </Box>
                                                                        </TableCell>
                                                                    );
                                                                }

                                                                if (col.field === 'orderedOn') {
                                                                    const dateValue = r[col.field];
                                                                    let formattedDate = '-';
                                                                    if (dateValue) {
                                                                        const d = new Date(dateValue);
                                                                        formattedDate = `${d.getDate().toString().padStart(2, '0')}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getFullYear()}`;
                                                                    }
                                                                    return (
                                                                        <TableCell key={col.field} sx={{ padding: '8px' }}>
                                                                            {formattedDate}
                                                                        </TableCell>
                                                                    );
                                                                }

                                                                if (col.field === 'containerName') {
                                                                    return (
                                                                        <TableCell
                                                                            key={col.field}
                                                                            sx={{
                                                                                padding: '16px',
                                                                                whiteSpace: 'normal',
                                                                                wordBreak: 'break-word',
                                                                                overflowWrap: 'anywhere'
                                                                            }}
                                                                        >
                                                                            <Typography
                                                                                variant="body2"
                                                                                sx={{
                                                                                    whiteSpace: 'normal',
                                                                                    wordBreak: 'break-word',
                                                                                    overflowWrap: 'anywhere',
                                                                                    fontWeight: 600
                                                                                }}
                                                                            >{getItemDisplayName(r)}</Typography>
                                                                        </TableCell>
                                                                    );
                                                                }

                                                                if (col.field === 'status') {
                                                                    let statusText = '-';
                                                                    if (r.status === 1) statusText = 'Requested';
                                                                    else if (r.status === 2) statusText = 'Inprogress';
                                                                    else if (r.status === 3) statusText = 'Completed';
                                                                    return (
                                                                        <TableCell key={col.field} sx={{ padding: '8px' }}>
                                                                            {statusText}
                                                                        </TableCell>
                                                                    );
                                                                }

                                                                if (col.isEnable) {
                                                                    if (col.field === 'fulfilledQuantity' && col.validation) {
                                                                        let fulfilledValue = r?.status === 2 && r.fulfilledQuantity === null ? "" : r?.fulfilledQuantity;
                                                                        return (
                                                                            <TableCell key={col.field} sx={{ padding: '8px' }}>
                                                                                <Box className="print-hide">
                                                                                    <TextField
                                                                                        size="small"
                                                                                        variant="outlined"
                                                                                        fullWidth
                                                                                        value={fulfilledValue}
                                                                                        onChange={userType === 'Internal' && !r.isCompleted && rows?.status === 2 ? e => { const value = e.target.value; if (value === '' || /^\d*$/.test(value)) { handleCellChange(idx, col.field, value, false); } } : undefined}
                                                                                        onBlur={userType === 'Internal' && !r.isCompleted && rows?.status === 2 ? e => { const value = e.target.value; if (value === '' || isNaN(Number(value)) || Number(value) < 0) { handleCellChange(idx, col.field, 0, false); } } : undefined}
                                                                                        type="text"
                                                                                        inputProps={{ style: { width: 60 } }}
                                                                                        InputProps={{ readOnly: userType !== 'Internal' || r.isCompleted || rows?.status !== 2 || r.fulfilledDisabled }}
                                                                                        disabled={rows?.status === 1 || rows?.status === 3 || rows?.status === 4 || r.fulfilledDisabled}
                                                                                    />
                                                                                </Box>
                                                                                <Box className="print-status-text" sx={{ display: 'none', '@media print': { display: 'block !important' } }}>
                                                                                    <Typography variant="body2">
                                                                                        {fulfilledValue !== '' && fulfilledValue !== null && fulfilledValue !== undefined ? fulfilledValue : '-'}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </TableCell>
                                                                        );
                                                                    }
                                                                    if (col.field === 'comments') {
                                                                        const fulfilledValue = r.fulfilledQuantity ?? '';
                                                                        const commentsRequired =
                                                                            rows?.status === 2 &&
                                                                            fulfilledValue !== '' &&
                                                                            Number(fulfilledValue) !== Number(r.requestedQuantity);

                                                                        return (
                                                                            <TableCell key={col.field} sx={{ padding: '8px' }}>
                                                                                <Box className="print-hide">
                                                                                    <TextField
                                                                                        size="small"
                                                                                        variant="outlined"
                                                                                        fullWidth
                                                                                        select
                                                                                        label="Comments"
                                                                                        value={r.comments ?? ''}
                                                                                        sx={{ maxWidth: { xs: '100px', sm: '116px', md: '100%' } }}
                                                                                        onChange={
                                                                                            userType === 'Internal' && !r.isCompleted
                                                                                                ? (e) => {
                                                                                                    const value = e.target.value;

                                                                                                    // Update the comment
                                                                                                    handleCellChange(idx, col.field, value, false);

                                                                                                    // Trigger tick only when a valid comment is selected
                                                                                                    if (
                                                                                                        commentsRequired &&
                                                                                                        value &&
                                                                                                        value.trim() !== ''
                                                                                                    ) {
                                                                                                        handleTickToggle(idx, false, false);
                                                                                                    }
                                                                                                }
                                                                                                : undefined
                                                                                        }
                                                                                        InputProps={{
                                                                                            readOnly: userType !== 'Internal' || r.isCompleted,
                                                                                        }}
                                                                                        disabled={
                                                                                            rows?.status !== 2 ||
                                                                                            r.isCompleted ||
                                                                                            !commentsRequired
                                                                                        }
                                                                                        required={commentsRequired}
                                                                                        error={r.showCommentsError}
                                                                                        helperText={
                                                                                            r.showCommentsError ? 'Comments is required' : ''
                                                                                        }
                                                                                    >
                                                                                        <MenuItem value="">
                                                                                            Select comment
                                                                                        </MenuItem>
                                                                                        {commentOptions.map((option) => (
                                                                                            <MenuItem key={option} value={option}>
                                                                                                {option}
                                                                                            </MenuItem>
                                                                                        ))}
                                                                                    </TextField>
                                                                                </Box>

                                                                                <Box
                                                                                    className="print-status-text"
                                                                                    sx={{
                                                                                        display: 'none',
                                                                                        '@media print': {
                                                                                            display: 'block !important',
                                                                                        },
                                                                                    }}
                                                                                >
                                                                                    <Typography variant="body2">
                                                                                        {r.comments ?? '-'}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </TableCell>
                                                                        );
                                                                    }
                                                                    return (
                                                                        <TableCell key={col.field} sx={{ padding: '8px' }}>
                                                                            <TextField
                                                                                size="small"
                                                                                variant="outlined"
                                                                                fullWidth
                                                                                value={r[col.field] ?? ''}
                                                                                onChange={userType === 'Internal' && !r.isCompleted ? e => handleCellChange(idx, col.field, e.target.value, false) : undefined}
                                                                                InputProps={{ readOnly: userType !== 'Internal' || r.isCompleted }}
                                                                                disabled={rows?.status === 3}
                                                                            />
                                                                        </TableCell>
                                                                    );
                                                                }

                                                                if (col.field === 'requestedQuantity') {
                                                                    let requestedValue = r?.status === 2 && r.requestedQuantity === null ? "" : r?.requestedQuantity;
                                                                    return (
                                                                        <TableCell key={col.field} sx={{ padding: '8px' }}>
                                                                            <Box className="print-hide">
                                                                                <TextField
                                                                                    size="small"
                                                                                    variant="outlined"
                                                                                    fullWidth
                                                                                    value={requestedValue}
                                                                                    onChange={canEditRequestedQuantity(r) && !r.requestedDisabled ? e => { const value = e.target.value; if (value === '' || /^\d*$/.test(value)) { handleCellChange(idx, col.field, value, false); } } : undefined}
                                                                                    type="text"
                                                                                    inputProps={{ style: { width: 60 } }}
                                                                                    InputProps={{ readOnly: !canEditRequestedQuantity(r) || r.requestedDisabled }}
                                                                                    disabled={!canEditRequestedQuantity(r) || r.requestedDisabled}
                                                                                />
                                                                            </Box>
                                                                            <Box className="print-status-text" sx={{ display: 'none', '@media print': { display: 'block !important' } }}>
                                                                                <Typography variant="body2">
                                                                                    {requestedValue !== '' && requestedValue !== null && requestedValue !== undefined ? requestedValue : '-'}
                                                                                </Typography>
                                                                            </Box>
                                                                        </TableCell>
                                                                    );
                                                                }

                                                                return (
                                                                    <TableCell key={col.field} sx={{ padding: '16px' }}>
                                                                        {r[col.field] !== undefined && r[col.field] !== null && r[col.field] !== '' ? r[col.field] : '-'}
                                                                    </TableCell>
                                                                );
                                                            })}
                                                            {renderItemDeleteAction(r, idx, false)}
                                                        </TableRow>
                                                    ))
                                                )}
                                            </TableBody>
                                        </Table>
                                    </div>
                                </CardContent>
                            </Card>
                        </Box>
                        {
                            userType === 'Internal' && (
                                <Box mt={3}>
                                    <Card variant="outlined" sx={{ borderRadius: 1 }}>
                                        <CardContent>
                                            <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
                                                Additional Comments
                                            </Typography>
                                            <Box
                                                className="print-status-text"
                                                sx={{
                                                    display: 'none',
                                                    '@media print': { display: 'block !important' }
                                                }}
                                            >
                                                <Typography variant="body2">
                                                    {localRows.comments?.trim() || 'No additional comments'}
                                                </Typography>
                                            </Box>
                                            <Box className="print-hide">
                                                <TextField
                                                    placeholder="Enter additional comments here"
                                                    multiline
                                                    minRows={3}
                                                    fullWidth
                                                    variant="outlined"
                                                    value={localRows.comments || ''}
                                                    onChange={e => setLocalRows((prev: any) => ({ ...prev, comments: e.target.value }))}
                                                    disabled={rows?.status === 3}
                                                />
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Box>
                            )
                        }
                    </div >
                    <Dialog
                        open={labelPrintDialogOpen}
                        onClose={() => setLabelPrintDialogOpen(false)}
                        maxWidth="xs"
                        fullWidth
                    >
                        <DialogTitle>Print Labels</DialogTitle>
                        <DialogContent>
                            <Box
                                className="label-print-controls"
                                sx={{
                                    pt: 1,
                                    display: 'flex',
                                    alignItems: { xs: 'stretch', sm: 'center' },
                                    flexDirection: { xs: 'column', sm: 'row' },
                                    gap: 1.5
                                }}
                            >
                                <Typography variant="body2" sx={{ color: '#2c3e50', fontWeight: 500, flex: 1 }}>
                                    Number of Label Pages to print
                                </Typography>
                                <TextField
                                    type="number"
                                    size="small"
                                    value={labelPrintCopies}
                                    onChange={(e) => {
                                        const value = e.target.value;

                                        if (value === '') {
                                            setLabelPrintCopies('');
                                            return;
                                        }

                                        setLabelPrintCopies(Math.max(1, Number(value)));
                                    }}
                                    onBlur={() => {
                                        if (labelPrintCopies === '' || Number(labelPrintCopies) < 1) {
                                            setLabelPrintCopies(1);
                                        }
                                    }}
                                    inputProps={{ min: 1, style: { width: 80 } }}
                                />
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1.5, mt: 3 }}>
                                <Button variant="outlined" onClick={() => setLabelPrintDialogOpen(false)}>
                                    Cancel
                                </Button>
                                <Button variant="contained" onClick={handlePrintLabels} disabled={!labelQrSvg}>
                                    Print Labels
                                </Button>
                            </Box>
                        </DialogContent>
                    </Dialog>
                    <Dialog
                        open={groupPrintDialogOpen}
                        onClose={() => setGroupPrintDialogOpen(false)}
                        maxWidth="xs"
                        fullWidth
                    >
                        <DialogTitle>Print Groups</DialogTitle>
                        <DialogContent>
                            <Box className="group-print-controls" sx={{ pt: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
                                <TextField
                                    select
                                    fullWidth
                                    size="small"
                                    label="Bottle Group"
                                    value={selectedGroupPrintIndex}
                                    onChange={(e) => setSelectedGroupPrintIndex(e.target.value === '' ? '' : Number(e.target.value))}
                                >
                                    {bottleGroupRows.map((group, idx) => (
                                        <MenuItem key={group.id ?? idx} value={idx}>
                                            {resolveBottleGroupName(group, idx)}
                                        </MenuItem>
                                    ))}
                                </TextField>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: { xs: 'stretch', sm: 'center' },
                                        flexDirection: { xs: 'column', sm: 'row' },
                                        gap: 1.5
                                    }}
                                >
                                    <Typography variant="body2" sx={{ color: '#2c3e50', fontWeight: 500, flex: 1 }}>
                                        Number of Pages to print
                                    </Typography>
                                    <TextField
                                        type="number"
                                        size="small"
                                        value={groupPrintCopies}
                                        onChange={(e) => {
                                            const value = e.target.value;

                                            if (value === '') {
                                                setGroupPrintCopies('');
                                                return;
                                            }

                                            setGroupPrintCopies(Math.max(1, Number(value)));
                                        }}
                                        onBlur={() => {
                                            if (groupPrintCopies === '' || Number(groupPrintCopies) < 1) {
                                                setGroupPrintCopies(1);
                                            }
                                        }}
                                        inputProps={{ min: 1, style: { width: 80 } }}
                                    />
                                </Box>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1.5, mt: 3 }}>
                                <Button variant="outlined" onClick={() => setGroupPrintDialogOpen(false)}>
                                    Cancel
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={handlePrintGroups}
                                    disabled={selectedGroupPrintIndex === ''}
                                >
                                    Print Groups
                                </Button>
                            </Box>
                        </DialogContent>
                    </Dialog>
                    <Dialog
                        open={unfulfilledOrderDialogOpen}
                        onClose={(_, reason) => {
                            if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                                return;
                            }

                            setUnfulfilledOrderDialogOpen(false);
                        }}
                        disableEscapeKeyDown
                        maxWidth="xs"
                        fullWidth
                    >
                        <DialogTitle> Do you wish to create an order for unfulfilled items?</DialogTitle>
                        <DialogContent>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1.5, mt: 3 }}>
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        createUnfulfilledOrderRef.current = false;
                                        setHasAnsweredUnfulfilledPrompt(true);
                                        handleConfirm(3, 'submit', 2);
                                        setUnfulfilledOrderDialogOpen(false);
                                    }}
                                >
                                    No
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={() => {
                                        createUnfulfilledOrderRef.current = true;
                                        setHasAnsweredUnfulfilledPrompt(true);
                                        handleConfirm(3, 'submit', 2);
                                        setUnfulfilledOrderDialogOpen(false);
                                    }}
                                >
                                    Yes
                                </Button>
                            </Box>
                        </DialogContent>
                    </Dialog>
                    <Dialog
                        open={confirmOpen}
                        onClose={() => setConfirmOpen(false)}
                        maxWidth="sm"
                        fullWidth
                    >
                        <DialogTitle>Are you sure you want to reject this Order #{rows?.id}</DialogTitle>
                        <DialogContent>
                            <TextField
                                placeholder="Enter the reason for rejecting this order"
                                multiline
                                minRows={3}
                                fullWidth
                                required
                                variant="outlined"
                                value={localRows.comments || ''}
                                onChange={e => {
                                    setLocalRows((prev: any) => ({
                                        ...prev,
                                        comments: e.target.value,
                                    }));

                                    if (e.target.value.trim()) {
                                        setRejectError('');
                                    }
                                }}
                                error={!!rejectError}
                                helperText={rejectError}
                                disabled={rows?.status === 3}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => setConfirmOpen(false)}
                                color="inherit"
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={() => {
                                    handleRejectConfirm();
                                }}
                                variant="contained"
                            >
                                Confirm
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <QuoteContainerCheckoutDialog
                        open={containerDialogOpen}
                        quote={selectedQuoteForContainers}
                        quoteAnalysisReference={selectedQuoteForContainers?.quoteAnalysisReference}
                        clientId={7209}
                        onClose={() => {
                            setContainerDialogOpen(false);
                            setSelectedQuoteForContainers(null);
                        }}
                    />
                    <Box mt={3} textAlign="right" className="action-buttons no-print">
                        <Button
                            onClick={() => {
                                setOpen(false);
                            }}
                            variant="outlined"
                            color="primary"
                            sx={{ mr: 1 }}
                        >
                            Cancel
                        </Button>
                        {rows?.status !== 4 && <Button
                            onClick={() => handleReject()}
                            variant="contained"
                            color="error"
                            sx={{ mr: 1 }}
                            disabled={
                                hasViewContainerPermission ||
                                !labUserCheck?.Permission?.includes('EditContainerOrder') ||
                                rows?.status === 4 ||
                                tabStatus === 4
                            }
                        >
                            Reject
                        </Button>}
                        {userType === 'Internal' && (
                            <>
                                <Button
                                    onClick={() => handleConfirm(rows?.status, 'saveDraft', 1)}
                                    variant="contained"
                                    color="primary"
                                    sx={{ mr: 1 }}
                                    disabled={
                                        hasViewContainerPermission ||
                                        !labUserCheck?.Permission?.includes('EditContainerOrder') ||
                                        rows?.status === 4 ||
                                        tabStatus === 4
                                    }
                                >
                                    Save As Draft
                                </Button>
                                <Tooltip
                                    title={rows?.status === 2 ? 'Please mark all items in Containers and Packages as completed.' : ''}
                                    arrow
                                    disableHoverListener={rows?.status !== 2}
                                >
                                    <span>
                                        <Button
                                            onClick={() => {
                                                // Set packedClicked true to trigger error display
                                                if (rows.status === 2) {
                                                    // Only allow submit if no comments error
                                                    const allRows = [...containerRows, ...packageRows];
                                                    const groupedRows = [...bottleGroupRows];
                                                    const allEditableRows = [...allRows, ...groupedRows];
                                                    const hasCommentsError = allEditableRows.some(r => {
                                                        const fulfilledValue = r.fulfilledQuantity ?? '';
                                                        const commentsRequired = fulfilledValue !== '' && Number(fulfilledValue) !== Number(r.requestedQuantity);
                                                        return commentsRequired && !(r.comments && r.comments.trim());
                                                    });
                                                    if (!hasCommentsError) {
                                                        if (shouldPromptForUnfulfilledOrder && !hasAnsweredUnfulfilledPrompt) {
                                                            setUnfulfilledOrderDialogOpen(true);
                                                        } else {
                                                            handleConfirm(rows?.status + 1, 'submit', rows?.status);
                                                        }
                                                    }
                                                } else {
                                                    handleConfirm(rows?.status + 1, 'submit', rows?.status);
                                                }
                                            }}
                                            variant="contained"
                                            color="primary"
                                            disabled={
                                                hasViewContainerPermission ||
                                                !labUserCheck?.Permission?.includes('EditContainerOrder') ||
                                                rows?.status === 4 ||
                                                tabStatus === 4 ||
                                                isConfirmDisabled()
                                            }
                                        >
                                            {(() => {
                                                if (rows?.status === 1) return 'Confirm';
                                                if (rows?.status === 2) return 'Packed';
                                                if (rows?.status === 3) return 'Despatched';
                                                if (rows?.status === 4) return 'Submit';
                                                return 'Confirm';
                                            })()}
                                        </Button>
                                    </span>
                                </Tooltip>
                            </>
                        )}
                    </Box>
                </DialogContent >
            </Dialog >
            <Snackbar
                open={message.open}
                autoHideDuration={3000}
                onClose={() => setMessage({ ...message, open: false })}
            >
                <Alert onClose={() => setMessage({ ...message, open: false })} severity={message.type} sx={{ width: '100%' }}>
                    <b>{message.text}</b>
                </Alert>
            </Snackbar>
        </>
    );
};
